<template>
    <div class="flex flex-col gap-10">
        <!-- VISTA SOLO ASIGNADO: Cuando solo se quiere editar la persona asignada -->
        <div v-if="showOnlyAssigned" class="flex flex-col gap-10">
            <!-- <div v-if="formType !== 'other_type'" class="flex flex-col gap-4">
                <h2 class="text-[var(--c-primary)]">{{ $t('assignedUser.title') }}</h2>
                <div class="flex flex-col gap-2">
                    <label class="label truncate text-[#385660]" :title="$t('assignedUser.label')">{{
                        $t('assignedUser.label') }}</label>
                        class="input-container shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex items-center border border-[#3A5762] rounded-lg px-3">
                        <input
                            class="input truncate flex-1 py-2 h-10 text-sm border-none outline-none text-[#7CADB9] transition-all duration-300 whitespace-nowrap overflow-hidden text-ellipsis cursor-help"
                            :placeholder="$t('assignedUser.placeholder')"
                    </div>
                            :value="assignedUserName || formData.assigned_to || ''" readonly
                            style="--placeholder-color: #25B0D7; background-color: transparent; color: #7CADB9;" />

-->
            <!-- MODAL: Búsqueda de usuarios -->
            <div v-if="showUserSearchModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
                    <!-- Header -->
                    <div class="flex items-center justify-between p-6 border-b">
                        <h3 class="text-lg font-semibold text-[#385660]">{{
                            $t('requestDetailAdmin.modalUserSearch.title') }}</h3>
                        <button @click="closeUserSearchModal"
                            class="text-gray-400 hover:text-gray-600 transition-colors">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>

                    <!-- Search Input -->
                    <div class="p-6 border-b">
                        <div class="relative" ref="addressSearchContainer" @keydown.esc="closeAutocompleteDropdowns()" @keydown.tab="showAddressSearch = false">
                            <input v-model="userSearchQuery" @input="searchUsers" type="text"
                                :placeholder="$t('requestDetailAdmin.modalUserSearch.searchPlaceholder')"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent" />
                            <div v-if="isSearchingUsers" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]"></div>
                            </div>
                        </div>
                    </div>

                    <!-- User List -->
                    <div class="flex-1 overflow-y-auto p-6">
                        <div v-if="isSearchingUsers && !searchedUsers.length" class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalUserSearch.searching') }}
                        </div>
                        <div v-else-if="!isSearchingUsers && !searchedUsers.length && userSearchQuery"
                            class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalUserSearch.noResults') }}
                        </div>
                        <div v-else-if="!userSearchQuery" class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalUserSearch.startTyping') }}
                        </div>
                        <div v-else class="space-y-2">
                            <button v-for="user in searchedUsers" :key="user.id" @click="selectUser(user)"
                                class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors">
                                <div class="font-medium text-[#385660]">{{ user.name }}</div>
                                <div v-if="user.email" class="text-sm text-gray-500">{{ user.email }}</div>
                            </button>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="p-6 border-t flex justify-end space-x-3">
                        <button @click="closeUserSearchModal"
                            class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                            {{ $t('requestDetailAdmin.modalUserSearch.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- FORMULARIO COMPLETO: Vista principal del formulario -->
        <template v-else>
            <!-- Título del formulario. El subtítulo va centrado sobre los campos, más abajo -->
            <div class="flex flex-col justify-between lg:flex-row gap-4">
                <titlePrimary class="shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]" :title="getFormTitle" />
            </div>
            <!-- username si a entrado un formulario con datos y con role superadmin -->
            <div v-if="isSuperadmin && assignedUserName" class="text-sm text-[#385660]">
                 {{ assignedUserName }}
            </div>

            <!-- Cliente para el que ADS tramita la solicitud (SOL-07). Se elige la
                 cuenta (administrador de fincas / API / inmobiliaria), no una persona. -->
            <div v-if="canPickClientAccount && !isEditMode" class="flex flex-col gap-2">
                <h2 class="text-[var(--c-primary)]">{{ $t('form.client.title') }} <span aria-hidden="true">*</span></h2>
                <div class="flex flex-col sm:flex-row sm:items-center gap-3">
                    <div class="flex-1 border border-gray-300 rounded-md px-3 py-2 min-h-[44px] flex flex-col justify-center">
                        <template v-if="selectedAccount">
                            <span class="text-[#385660] font-medium">{{ selectedAccount.name }}</span>
                            <span class="text-xs text-gray-500">
                                {{ accountTypeLabel(selectedAccount, '') }}<span v-if="selectedAccount.email"> · {{ selectedAccount.email }}</span>
                            </span>
                        </template>
                        <span v-else class="text-gray-400">{{ $t('form.client.none') }}</span>
                    </div>
                    <button type="button" @click="openAccountSearchModal"
                        class="px-4 py-2 rounded-lg border border-[#2AB4D9] text-[#2AB4D9] hover:bg-[#2AB4D9]/10 transition-colors">
                        {{ selectedAccount ? $t('form.client.change') : $t('form.client.search') }}
                    </button>
                </div>
                <span v-if="isSubmitted && hasClientAccountError" class="text-red-500 text-sm">{{ $t('form.errors.clientAccount') }}</span>
            </div>

            <!-- MODAL: Búsqueda de cuentas cliente -->
            <div v-if="showAccountSearchModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
                    <div class="flex items-center justify-between p-6 border-b">
                        <h3 class="text-lg font-semibold text-[#385660]">{{ $t('requestDetailAdmin.modalClientSearch.title') }}</h3>
                        <button type="button" @click="closeAccountSearchModal" class="text-gray-400 hover:text-gray-600 transition-colors">
                            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="p-6 border-b">
                        <div class="relative">
                            <input v-model="accountSearchQuery" @input="searchAccounts" type="text"
                                :placeholder="$t('requestDetailAdmin.modalClientSearch.searchPlaceholder')"
                                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent" />
                            <div v-if="isSearchingAccounts" class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]"></div>
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 overflow-y-auto p-6">
                        <div v-if="isSearchingAccounts && !searchedAccounts.length" class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalClientSearch.searching') }}
                        </div>
                        <div v-else-if="!isSearchingAccounts && !searchedAccounts.length && accountSearchQuery"
                            class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalClientSearch.noResults') }}
                        </div>
                        <div v-else-if="!accountSearchQuery" class="text-center py-8 text-gray-500">
                            {{ $t('requestDetailAdmin.modalClientSearch.startTyping') }}
                        </div>
                        <div v-else class="space-y-2">
                            <button v-for="account in searchedAccounts" :key="account.id" type="button" @click="selectAccount(account)"
                                class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors">
                                <div class="font-medium text-[#385660]">{{ account.name }}</div>
                                <div class="text-sm text-gray-500">
                                    {{ accountTypeLabel(account, '') }}<span v-if="account.email"> · {{ account.email }}</span>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="p-6 border-t flex justify-end space-x-3">
                        <button type="button" @click="closeAccountSearchModal"
                            class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                            {{ $t('requestDetailAdmin.modalClientSearch.cancel') }}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Subtítulo centrado justo encima de los datos a rellenar (pedido de ADS, 10-09-2026) -->
            <div class="flex justify-center">
                <titlePrimary class="px-20 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]" bgColor="bg-[#00000]"
                    textColor="text-[#7CADB9]" :title="getFormSubtitle" />
            </div>

            <!-- Layout de 3 columnas -->
            <div class="flex flex-col gap-8 lg:gap-20"
                :class="formType === 'other_type' ? 'lg:grid lg:grid-cols-3' : 'lg:flex-row'">
                <!-- COLUMNA 1: Tipo de suministro, CUPS, Estado y Cuenta bancaria -->
                <div class="flex flex-col gap-10" :class="formType === 'other_type' ? 'lg:min-w-0' : 'lg:w-1/3'">
                    <div v-if="formType === 'other_type'" class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('form.otherAction.title') }}</h2>

                        <div class="flex flex-col gap-3">
                            <label class="text-sm font-medium text-[#385660]">{{ $t('form.otherAction.label') }} <span aria-hidden="true">*</span></label>
                            <select v-model="formData.other_action"
                                :class="{ 'border-red-500': isSubmitted && hasOtherActionError }"
                                class="w-full border rounded-lg px-3 py-2 text-[#7CADB9]">
                                <option value="">{{ $t('form.otherAction.placeholder') }}</option>
                                <option v-if="allowsPowerModification" value="modificar_potencia"> {{ $t('common.requestTypes.modificar_potencia') }} </option>
                                <option value="estado_pagos"> {{ $t('common.requestTypes.estado_pagos') }} </option>
                                <option value="carta_pago"> {{ $t('common.requestTypes.carta_pago') }} </option>
                                <option value="error_factura"> {{ $t('common.requestTypes.error_facturacion') }} </option>
                                <option value="baja_suministro"> {{ $t('common.requestTypes.baja_suministro') }} </option>
                                <option value="cambio_direccion_postal"> {{ $t('common.requestTypes.cambio_direccion_postal') }} </option>
                                <option value="otros">{{ $t('common.requestTypes.otros') }}</option>
                            </select>
                            <span v-if="isSubmitted && hasOtherActionError" class="text-red-500 text-sm">
                                {{ $t('requestTypeChange.selectSubcategory') }}
                            </span>
                        </div>

                        <div v-if="formData.other_action === 'cambio_direccion_postal'" class="mt-4">
                            <inputPrimaryVue :modelValue="formData.email" @update:modelValue="formData.email = $event"
                                :label="'Email'" :placeholder="'Email de contacto'" type="email" />
                        </div>
                        <div class="mt-4">
                            <!-- Teléfono del titular y su excepción; al modificar se respeta lo indicado al crear. -->
                            <HolderTelephoneField id-suffix="Other"
                                :telephone="formData.telephone"
                                :unavailable="formData.telephone_unavailable"
                                :shows-unavailable="showsTelephoneUnavailable"
                                :locked="telephoneLocked"
                                :invalid="isSubmitted && hasOwnerError.telephone"
                                @update:telephone="handleTelephoneUpdate"
                                @update:unavailable="handleTelephoneUnavailableChange"
                                @unlock="unlockTelephone" />
                        </div>
                    </div>
                    <!-- SECCIÓN: Tipo de Suministro -->
                    <div class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('supplyTypes.title') }} <span aria-hidden="true">*</span></h2>
                        <div class="flex flex-row justify-evenly gap-2">
                            <div v-for="(option, index) in supplyOptions" :key="index"
                                class="relative w-23 h-35 border rounded-md cursor-pointer transition-all hover:bg-[#25b0d725] duration-500 hover:scale-105 active:scale-100"
                                :class="{
                                    'border-[var(--c-primary)] border-2 shadow-lg': selectedOption === option.value,
                                    'shadow-[0_4px_4px_0_rgba(0,0,0,0.25)]': selectedOption !== option.value,
                                    'opacity-40 cursor-not-allowed pointer-events-none': isEnergyLocked && selectedOption !== option.value,
                                }" @click="selectOption(option.value)">
                                <p class="flex items-center justify-center h-10">
                                    {{ $t(`supplyTypes.options.${option.translationKey}`) }}
                                </p>
                                <div class="absolute w-full border-b-1"></div>
                                <div class="flex items-center justify-center">
                                    <component :is="option.icon" class="w-10"></component>
                                </div>
                            </div>
                        </div>
                        <p v-if="isEnergyLocked" class="text-xs text-gray-500">
                            {{ $t('supplyRequests.lockedEnergy', { cups: originSupply.cups || '-' }) }}
                        </p>
                        <span v-if="isSubmitted && hasSupplyTypeError" class="text-red-500 text-sm">
                            {{ $t('supplyTypes.errors.required') }}
                        </span>
                    </div>

                    <!-- SECCIÓN: CUPS -->
                    <div class="flex flex-col gap-4">
                        <div v-if="showCupsFields" class="mt-4 space-y-4">
                            <h2 class="text-[var(--c-primary)]">{{ $t('cupsForm.title') }}</h2>

                            <!-- Input CUPS Luz -->
                            <div v-if="shouldShowLightInput">
                                <div class="flex gap-2 flex-col relative" ref="cupsLightSearchContainer">
                                    <inputPrimaryVue :modelValue="formData.cups_light"
                                        @update:modelValue="handleCupsUpdate('light', $event)" type="text"
                                        :label="$t('cupsForm.labels.light')" :required="!sabeCUPS.light"
                                        :placeholder="$t('cupsForm.placeholders.default')" :disabled="sabeCUPS.light"
                                        :class="{ 'opacity-50': sabeCUPS.light }" />
                                    <div v-if="showCupsSearch.light && cupsSuggestions.light.length > 0"
                                        class="absolute z-50 bg-white border border-gray-200 rounded shadow w-full mt-20 max-h-48 overflow-auto">
                                        <div v-for="(suggestion, idx) in cupsSuggestions.light" :key="`light-${idx}`"
                                            @click="selectCupsSuggestion('light', suggestion)"
                                            class="px-4 py-2 hover:bg-blue-100 cursor-pointer text-sm text-[#385660]">
                                            {{ getCupsSuggestionValue(suggestion, 'light') }}
                                        </div>
                                    </div>
                                    <label class="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" :checked="sabeCUPS.light"
                                            @change="() => toggleNoSeCups('light')"
                                            class="w-4 h-4 text-[var(--c-primary)] bg-gray-100 border-gray-300 rounded focus:ring-[var(--c-primary)] focus:ring-2" />
                                        <span class="text-sm text-gray-700">
                                            {{ $t('cupsForm.buttons.toggle_cups') }}
                                        </span>
                                    </label>
                                </div>
                                <span v-if="isSubmitted && hasLightError" class="text-red-500 text-sm">
                                    {{ (!formData.cups_light || !formData.cups_light.trim()) ? $t('cupsForm.errors.light_required') : $t('cupsForm.errors.invalid') }}
                                </span>
                                <inputPrimaryVue v-if="showsMeterReadings" class="mt-4" :modelValue="formData.light_meter_reading"
                                    @update:modelValue="formData.light_meter_reading = $event" type="text"
                                    :label="$t('requestDetailAdmin.labels.lightMeterReading')"
                                    :placeholder="$t('requestDetailAdmin.labels.lightMeterReading')" />
                            </div>

                            <!-- Input CUPS Gas -->
                            <div v-if="shouldShowGasInput">
                                <div class="flex gap-2 flex-col relative" ref="cupsGasSearchContainer">
                                    <inputPrimaryVue :modelValue="formData.cups_gas"
                                        @update:modelValue="handleCupsUpdate('gas', $event)" type="text"
                                        :label="$t('cupsForm.labels.gas')" :required="!sabeCUPS.gas"
                                        :placeholder="$t('cupsForm.placeholders.default')" :disabled="sabeCUPS.gas"
                                        :class="{ 'opacity-50': sabeCUPS.gas }" />
                                    <div v-if="showCupsSearch.gas && cupsSuggestions.gas.length > 0"
                                        class="absolute z-50 bg-white border border-gray-200 rounded shadow w-full mt-20 max-h-48 overflow-auto">
                                        <div v-for="(suggestion, idx) in cupsSuggestions.gas" :key="`gas-${idx}`"
                                            @click="selectCupsSuggestion('gas', suggestion)"
                                            class="px-4 py-2 hover:bg-blue-100 cursor-pointer text-sm text-[#385660]">
                                            {{ getCupsSuggestionValue(suggestion, 'gas') }}
                                        </div>
                                    </div>
                                    <label class="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" :checked="sabeCUPS.gas"
                                            @change="() => toggleNoSeCups('gas')"
                                            class="w-4 h-4 text-[var(--c-primary)] bg-gray-100 border-gray-300 rounded focus:ring-[var(--c-primary)] focus:ring-2" />
                                        <span class="text-sm text-gray-700">
                                            {{ $t('cupsForm.buttons.toggle_cups') }}
                                        </span>
                                    </label>
                                </div>
                                <span v-if="isSubmitted && hasGasError" class="text-red-500 text-sm">
                                    {{ (!formData.cups_gas || !formData.cups_gas.trim()) ? $t('cupsForm.errors.gas_required') : $t('cupsForm.errors.invalid') }}
                                </span>
                                <inputPrimaryVue v-if="showsMeterReadings" class="mt-4" :modelValue="formData.gas_meter_reading"
                                    @update:modelValue="formData.gas_meter_reading = $event" type="text"
                                    :label="$t('requestDetailAdmin.labels.gasMeterReading')"
                                    :placeholder="$t('requestDetailAdmin.labels.gasMeterReading')" />
                            </div>
                        </div>
                    </div>

                    <!-- Request role selection: mostrar solo si el usuario tiene ambos roles -->
                    <div v-if="hasBothRoles" class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('form.labels.request_role') || 'Request role' }}<span v-if="!isEditMode" aria-hidden="true"> *</span></h2>
                        <div class="flex items-center gap-4">
                            <label class="flex items-center gap-2 cursor-pointer">
                                <input type="radio" name="request_role" value="vertical" v-model="formData.request_role" class="w-4 h-4" />
                                <span class="text-sm text-[#385660]">{{ $t('user.new.roles.vertical') || 'Vertical' }}</span>
                            </label>
                            <label class="flex items-center gap-2 cursor-pointer">
                                <input type="radio" name="request_role" value="horizontal" v-model="formData.request_role" class="w-4 h-4" />
                                <span class="text-sm text-[#385660]">{{ $t('user.new.roles.horizontal') || 'Horizontal' }}</span>
                            </label>
                        </div>
                        <span v-if="isSubmitted && hasRequestRoleError" class="text-red-500 text-sm">{{ t('suppliesForm.errors.request_role_required') || 'Debe seleccionar vertical u horizontal' }}</span>
                    </div>

                    <!-- SECCIÓN: Cuenta Bancaria -->
                    <div v-if="formType === 'account_change'"
                        class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('ownerForm.title_cuenta') }}</h2>
                        <div>
                            <inputPrimaryVue :modelValue="formData.iban" @update:modelValue="handleIbanUpdate"
                                :label="$t('ownerForm.labels.iban')" :placeholder="$t('ownerForm.placeholders.iban')"
                                :class="{ 'border-red-500': isSubmitted && hasBankError }" />
                            <p class="text-xs text-gray-500 mt-1 leading-4">
                                {{ $t('form.info.iban_optional') }}
                            </p>
                            <span v-if="isSubmitted && hasBankError" class="text-red-500 text-sm">
                                {{ $t('ownerForm.errors.iban.invalid') }}
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="formType !== 'other_type'" class="border-r border-gray-300"></div>

                <!-- COLUMNA 2: Datos del titular y dirección (para algunos formularios) -->
                <div v-if="formType !== 'other_type'" class=" flex flex-col gap-10 lg:w-1/3">
                    <!-- SECCIÓN: Datos del titular -->
                    <div v-if="formType !== 'account_change' && formType !== 'invoice' && formType !== 'other_type'"
                        class="compact-supply-fields flex flex-col gap-2">
                        <!-- Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla. -->
                        <!-- <h2 class="text-[var(--c-primary)]">{{ ownerSectionTitle }}</h2> -->
                        <h2 class="text-[var(--c-primary)]">{{ $t('ownerForm.title') }}</h2>

                        <!-- Nombre completo -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.contact_name"
                                @update:modelValue="formData.contact_name = $event"
                                :label="$t('ownerForm.labels.full_name')" required
                                :placeholder="$t('ownerForm.placeholders.full_name')"
                                :class="{ 'border-red-500': isSubmitted && hasOwnerError.name }" />
                            <span v-if="isSubmitted && hasOwnerError.name" class="text-red-500 text-sm">
                                {{ $t('ownerForm.errors.full_name.required') }}
                            </span>
                        </div>

                        <div>
                            <inputPrimaryVue :modelValue="formData.contact_person"
                                @update:modelValue="formData.contact_person = $event"
                                :label="$t('requestDetailAdmin.labels.contact_person')"
                                :placeholder="$t('requestDetailAdmin.labels.contact_person')" />
                        </div>

                        <!-- DNI/NIE (sin validación) -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.dni_nie"
                                @update:modelValue="formData.dni_nie = $event" :label="$t('ownerForm.labels.dni_nie')" required
                                :placeholder="$t('ownerForm.placeholders.dni_nie')"
                                :class="{ 'border-red-500': isSubmitted && hasOwnerError.dni }" />
                            <span v-if="isSubmitted && hasOwnerError.dni" class="text-red-500 text-sm">
                                {{ $t('ownerForm.errors.dni_nie.invalid') }}
                            </span>
                        </div>

                        <!-- Email. La etiqueta salía de ownerEmailLabel, retirado con «Cambio de comercializadora» (ADS-0130): el computed queda comentado más abajo. -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.email" @update:modelValue="formData.email = $event"
                                :label="$t('ownerForm.labels.email')" :placeholder="$t('ownerForm.placeholders.email')" required
                                type="email" :class="{ 'border-red-500': isSubmitted && hasOwnerError.email }" />
                            <span v-if="isSubmitted && hasOwnerError.email" class="text-red-500 text-sm">
                                {{ $t('ownerForm.errors.email.invalid') }}
                            </span>
                        </div>

                        <!-- Teléfono (solo para algunos tipos) -->
                        <!-- Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla. -->
                        <!-- <div v-if="formType === 'change_ownership' || formType === 'change_supplier' || formType === 'supplies'"> -->
                        <div v-if="formType === 'change_ownership' || formType === 'supplies'">
                            <!-- Teléfono del titular y su excepción; al modificar se respeta lo indicado al crear. -->
                            <HolderTelephoneField id-suffix="Owner"
                                :telephone="formData.telephone"
                                :unavailable="formData.telephone_unavailable"
                                :shows-unavailable="showsTelephoneUnavailable"
                                :locked="telephoneLocked"
                                :invalid="isSubmitted && hasOwnerError.telephone"
                                @update:telephone="handleTelephoneUpdate"
                                @update:unavailable="handleTelephoneUnavailableChange"
                                @unlock="unlockTelephone" />
                        </div>
                        <!-- IBAN para alta de suministro y cambio de titular -->
                        <!-- Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla. -->
                        <!-- <div v-if="formType === 'change_ownership' || formType === 'change_supplier' || formType === 'supplies'" class="mt-2"> -->
                        <div v-if="formType === 'change_ownership' || formType === 'supplies'" class="mt-2">
                            <inputPrimaryVue :modelValue="formData.iban" @update:modelValue="handleIbanUpdate"
                                :label="$t('ownerForm.labels.iban')" :placeholder="$t('ownerForm.placeholders.iban')"
                                :class="{ 'border-red-500': isSubmitted && hasBankError }" />
                            <p class="text-xs text-gray-500 mt-1 leading-4">
                                {{ $t('form.info.iban_optional') }}
                            </p>
                            <span v-if="isSubmitted && hasBankError" class="text-red-500 text-sm">
                                {{ $t('ownerForm.errors.iban.invalid') }}
                            </span>
                        </div>
                    </div>

                    <!-- SECCIÓN: Dirección del suministro (para cambio de cuenta y factura) -->
                    <div v-if="formType === 'account_change' || formType === 'invoice'" class="compact-supply-fields flex flex-col gap-2">
                        <h2 class="text-[var(--c-primary)]">{{ $t('supplyData.title') }}</h2>

                        <!-- Input dirección con autocompletado -->
                        <div class="relative" ref="addressSearchContainer" @keydown.esc="closeAutocompleteDropdowns()" @keydown.tab="showAddressSearch = false">
                            <inputPrimaryVue
                                :modelValue="formData.supply_address"
                                @update:modelValue="onSupplyAddressInput"
                                :label="$t('supplyData.labels.supply_address')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.supply_address')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.supply }"
                                @focus="showAddressSearch = true"
                                autocomplete="off"
                            />
                            <span v-if="isSubmitted && hasAddressError.supply" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                            <!-- Dropdown sugerencias -->
                            <div v-if="showAddressSearch && addressSuggestions.length > 0" class="absolute z-50 bg-white border border-gray-200 rounded shadow w-full mt-1 max-h-60 overflow-auto">
                                <div v-for="(suggestion, idx) in addressSuggestions" :key="idx" @click="selectAddressSuggestion(suggestion)" class="px-4 py-2 hover:bg-blue-100 cursor-pointer">
                                    <div class="font-medium">{{ suggestion.address }}</div>
                                    <div v-if="suggestion.postal_code || suggestion.municipality || (suggestion.property && suggestion.property.municipality)" class="text-xs text-gray-500">
                                        <span v-if="suggestion.postal_code">{{ suggestion.postal_code }}</span>
                                        <span v-if="suggestion.municipality || (suggestion.property && suggestion.property.municipality)"> - {{ suggestion.municipality || suggestion.property.municipality }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Código Postal -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.postal_code"
                                @update:modelValue="formData.postal_code = $event"
                                :label="$t('supplyData.labels.postal_code')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.postal_code')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.postal }" />
                            <span v-if="isSubmitted && hasAddressError.postal" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                        </div>

                        <!-- Campo Municipio -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.municipality"
                                @update:modelValue="formData.municipality = $event"
                                :label="$t('supplyData.labels.municipality')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.municipality')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.municipality }" />
                            <span v-if="isSubmitted && hasAddressError.municipality" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                        </div>
                        
                        <!--
                            Dirección de correspondencia: se pide en factura (junto con alta y
                            cambio de titular), no en cambio de cuenta ni en «Otro». Esta
                            sección la compartían factura y cambio de cuenta sin el bloque, así
                            que en factura había desaparecido.
                        -->
                        <template v-if="formType === 'invoice'">
                            <div class="flex items-center gap-2">
                                <input id="differentAddressCheckbox" type="checkbox" :checked="isDifferentAddress"
                                    @change="toggleDifferentAddress" class="w-4 h-4" />
                                <label class="text-sm" for="differentAddressCheckbox">{{
                                    $t('supplyData.labels.different_address') }}</label>
                            </div>
                            <div>
                                <inputPrimaryVue :modelValue="formData.user_address"
                                    @update:modelValue="formData.user_address = $event"
                                    :label="$t('supplyData.labels.correspondence_address')" :required="isDifferentAddress"
                                    :placeholder="$t('supplyData.placeholders.correspondence_address')"
                                    :disabled="!isDifferentAddress"
                                    :class="{ 'border-red-500': isSubmitted && hasAddressError.correspondence }" />
                                <span v-if="isSubmitted && hasAddressError.correspondence" class="text-red-500 text-sm">
                                    {{ $t('supplyData.errors.required') }}
                                </span>
                            </div>
                            <div>
                                <inputPrimaryVue :modelValue="formData.correspondence_population"
                                    @update:modelValue="formData.correspondence_population = $event"
                                    :label="$t('supplyData.labels.correspondence_population')" :required="isDifferentAddress"
                                    :placeholder="$t('supplyData.placeholders.correspondence_population')"
                                    :disabled="!isDifferentAddress"
                                    :class="{ 'border-red-500': isSubmitted && hasAddressError.correspondencePopulation }" />
                                <span v-if="isSubmitted && hasAddressError.correspondencePopulation" class="text-red-500 text-sm">
                                    {{ $t('supplyData.errors.required') }}
                                </span>
                            </div>
                        </template>

                        <!-- Teléfono (solo para algunos tipos) -->
                        <div>
                            <!-- Teléfono del titular y su excepción; al modificar se respeta lo indicado al crear. -->
                            <HolderTelephoneField id-suffix="Supply"
                                :telephone="formData.telephone"
                                :unavailable="formData.telephone_unavailable"
                                :shows-unavailable="showsTelephoneUnavailable"
                                :locked="telephoneLocked"
                                :invalid="isSubmitted && hasOwnerError.telephone"
                                @update:telephone="handleTelephoneUpdate"
                                @update:unavailable="handleTelephoneUnavailableChange"
                                @unlock="unlockTelephone" />
                        </div>

                    </div>

                    <HolderOptionalFields v-if="showsOptionalHolderFields && formType !== 'other_type'"
                        v-model:name="formData.contact_name"
                        v-model:surname="formData.contact_surname"
                        v-model:document="formData.dni_nie" />

                </div>

                <div v-if="formType !== 'other_type'" class="border-r border-gray-300"></div>

                <!-- COLUMNA 3: Dirección, archivos y formulario -->
                <div class="flex flex-col gap-10"
                    :class="formType === 'other_type' ? 'lg:col-span-2 lg:grid lg:grid-cols-2 lg:gap-20' : 'lg:w-1/3'">
                    <div :class="formType === 'other_type' ? 'flex flex-col gap-10 lg:border-r lg:border-gray-300 lg:pr-10' : 'contents'">
                    <!-- SECCIÓN: Dirección del suministro -->
                    <div v-if="formType !== 'account_change' && formType !== 'invoice'" class="compact-supply-fields flex flex-col gap-2">
                        <h2 class="text-[var(--c-primary)]">{{ $t('supplyData.title') }}</h2>

                        <!-- Input dirección principal -->
                        <div class="relative" ref="addressSearchContainer" @keydown.esc="closeAutocompleteDropdowns()" @keydown.tab="showAddressSearch = false">
                            <inputPrimaryVue
                                :modelValue="formData.supply_address"
                                @update:modelValue="onSupplyAddressInput"
                                :label="$t('supplyData.labels.supply_address')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.supply_address')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.supply }"
                                @focus="showAddressSearch = true"
                                autocomplete="off"
                            />
                            <span v-if="isSubmitted && hasAddressError.supply" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                            <!-- Dropdown sugerencias simples -->
                            <div v-if="showAddressSearch && addressSuggestions.length > 0" class="absolute z-50 bg-white border border-gray-200 rounded shadow w-full mt-1 max-h-60 overflow-auto">
                                <div v-for="(suggestion, idx) in addressSuggestions" :key="idx" @click="selectAddressSuggestion(suggestion)" class="px-4 py-2 hover:bg-blue-100 cursor-pointer">
                                    <div class="font-medium">{{ suggestion.address }}</div>
                                    <div v-if="suggestion.postal_code || suggestion.municipality" class="text-xs text-gray-500">
                                        <span v-if="suggestion.postal_code">{{ suggestion.postal_code }}</span>
                                        <span v-if="suggestion.municipality"> - {{ suggestion.municipality }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Código Postal -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.postal_code"
                                @update:modelValue="formData.postal_code = $event"
                                :label="$t('supplyData.labels.postal_code')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.postal_code')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.postal }" />
                            <span v-if="isSubmitted && hasAddressError.postal" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                        </div>

                        <!-- Campo Municipio -->
                        <div>
                            <inputPrimaryVue :modelValue="formData.municipality"
                                @update:modelValue="formData.municipality = $event"
                                :label="$t('supplyData.labels.municipality')" :required="requiresSupplyAddress"
                                :placeholder="$t('supplyData.placeholders.municipality')"
                                :class="{ 'border-red-500': isSubmitted && hasAddressError.municipality }" />
                            <span v-if="isSubmitted && hasAddressError.municipality" class="text-red-500 text-sm">
                                {{ $t('supplyData.errors.required') }}
                            </span>
                        </div>

                        <!--
                            Dirección de correspondencia: no se pide en «Otro tipo» ni en ninguno
                            de sus subtipos (ADS-0129). El detalle de esas solicitudes ya no la
                            mostraba, así que se rellenaba para nada. Se pide en alta, cambio de
                            titular y factura (esta última en su propia sección, más arriba).
                            Nada se borra: basta con quitar esta condición para volver a pedirla.
                        -->
                        <template v-if="formType !== 'other_type'">
                            <!-- Checkbox dirección diferente -->
                            <div class="flex items-center gap-2">
                                <input id="differentAddressCheckbox" type="checkbox" :checked="isDifferentAddress"
                                    @change="toggleDifferentAddress" class="w-4 h-4" />
                                <label class="text-sm" for="differentAddressCheckbox">{{
                                    $t('supplyData.labels.different_address') }}</label>
                            </div>

                            <!-- Dirección de correspondencia -->
                            <div>
                                <inputPrimaryVue :modelValue="formData.user_address"
                                    @update:modelValue="formData.user_address = $event"
                                    :label="$t('supplyData.labels.correspondence_address')" :required="isDifferentAddress"
                                    :placeholder="$t('supplyData.placeholders.correspondence_address')"
                                    :disabled="!isDifferentAddress"
                                    :class="{ 'border-red-500': isSubmitted && hasAddressError.correspondence }" />
                                <span v-if="isSubmitted && hasAddressError.correspondence" class="text-red-500 text-sm">
                                    {{ $t('supplyData.errors.required') }}
                                </span>
                            </div>

                            <!-- Población de correspondencia -->
                            <div>
                                <inputPrimaryVue :modelValue="formData.correspondence_population"
                                    @update:modelValue="formData.correspondence_population = $event"
                                    :label="$t('supplyData.labels.correspondence_population')" :required="isDifferentAddress"
                                    :placeholder="$t('supplyData.placeholders.correspondence_population')"
                                    :disabled="!isDifferentAddress"
                                    :class="{ 'border-red-500': isSubmitted && hasAddressError.correspondencePopulation }" />
                                <span v-if="isSubmitted && hasAddressError.correspondencePopulation" class="text-red-500 text-sm">
                                    {{ $t('supplyData.errors.required') }}
                                </span>
                            </div>
                        </template>
                    </div>

                    <HolderOptionalFields v-if="showsOptionalHolderFields && formType === 'other_type'"
                        v-model:name="formData.contact_name"
                        v-model:surname="formData.contact_surname"
                        v-model:document="formData.dni_nie" />
                    </div>

                    <div :class="formType === 'other_type' ? 'flex flex-col gap-10' : 'contents'">
                    <!-- Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla. -->
                    <!-- <div v-if="formType === 'supplies' || formType === 'change_ownership' || formType === 'change_supplier'" class="flex flex-col gap-2"> -->
                    <div v-if="formType === 'supplies' || formType === 'change_ownership'" class="flex flex-col gap-2">
                        <label class="flex items-start gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                v-model="formData.includes_water"
                                class="w-4 h-4 mt-1"
                            />
                            <span class="text-sm text-[#385660]">{{ $t('form.labels.includes_water') }}</span>
                        </label>
                    </div>

                    <!-- SECCIÓN: Subir archivos -->
                    <div class="flex flex-col gap-4">
                        <div class="flex flex-wrap items-baseline gap-x-2 gap-y-1">
                            <h2 class="text-[var(--c-primary)]">{{ $t('fileUpload.title') }}</h2>
                            <p class="text-sm italic text-[#7F7F7F]">{{ $t('fileUpload.titleHint') }}</p>
                        </div>
                        <div class="flex flex-col gap-2">
                            <input type="file" ref="fileInput" @change="handleFileChange" class="hidden" multiple
                                accept=".pdf,.png,.jpg,.jpeg,.doc,.docx,.xlsx,.xls,.csv,application/pdf,image/png,image/jpeg,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv" />
                            <ButtonWhiteVue @click="triggerFileUpload" class="w-full" bgColor="bg-[#2AB4D9]"
                                hoverBgColor="hover:bg-[#3ac3e9]" textColor="text-white">
                                <div class="flex items-center gap-2 text-center justify-center align-center">
                                    <span>{{ $t('fileUpload.button.upload') }}</span>
                                </div>
                            </ButtonWhiteVue>
                            <p class="text-sm text-[#7F7F7F]">{{ $t('fileUpload.allowedFormats') }}</p>
                            <p v-if="fileError" class="text-sm text-red-500">
                                {{ $t(`fileUpload.errors.${fileErrorKey}`) }}
                            </p>
                        </div>

                        <!-- Lista archivos subidos -->
                        <div v-if="uploadedFiles.length > 0" class="mt-4">
                            <div class="space-y-2">
                                <div v-for="(file, index) in uploadedFiles" :key="index"
                                    class="flex flex-col gap-3 p-3 bg-gray-50 rounded-lg sm:flex-row sm:items-center sm:justify-between">
                                    <div class="flex min-w-0 items-center gap-2">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-400"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 11.586 7.707 10.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                clip-rule="evenodd" />
                                        </svg>
                                        <span class="text-sm truncate max-w-[200px]">{{ file.file_name }}</span>
                                    </div>
                                    <div class="flex items-center gap-2 sm:w-1/2">
                                        <div class="flex min-w-0 flex-1 flex-col gap-1">
                                            <label class="text-xs text-[#385660]" :for="`documentalType${index}`">
                                                {{ $t('requestFiles.modal.documentalType') }} <span aria-hidden="true">*</span>
                                            </label>
                                        <select
                                            :id="`documentalType${index}`"
                                            v-model="file.documental_type"
                                            class="min-w-0 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 focus:border-[#2AB4D9] focus:outline-none focus:ring-2 focus:ring-sky-100"
                                            :aria-label="$t('requestFiles.modal.documentalType')"
                                            @change="handleDocumentalTypeChange">
                                            <option value="" disabled>{{ $t('requestFiles.modal.selectDocumentalType') }}</option>
                                            <option v-for="option in documentTypeOptions" :key="option.value" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                        </div>
                                        <button type="button" @click="removeFile(index)" class="shrink-0 text-red-500 hover:text-red-700">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20"
                                                fill="currentColor">
                                                <path fill-rule="evenodd"
                                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <p v-if="documentalTypeError" class="mt-2 text-sm text-red-500">
                                {{ $t('requestFiles.errors.documentalTypeRequired') }}
                            </p>
                        </div>

                        <!-- Error de archivo solo se muestra debajo del input de archivo -->
                    </div>

                    <!-- --------------------- Observación --------------------- -->
                    <!-- <div class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('observations.title') }}</h2>
                        <div>
                            <textarea v-model="formData.observations"
                                :class="{ 'border-red-500': isSubmitted && hasObservationError }"
                                class="w-full p-2 border rounded-md" :placeholder="$t('observations.placeholder')"
                                rows="4"></textarea>
                            <span v-if="isSubmitted && hasObservationError" class="text-red-500 text-sm">
                                {{ $t('observations.errors.required') }}
                            </span>
                        </div>
                    </div> -->

                    <!-- SECCIÓN: Persona asignada (solo para superadmin) -->
                    <!-- <div v-if="isSuperadmin && formType !== 'other_type'" class="flex flex-col gap-4">
                        <h2 class="text-[var(--c-primary)]">{{ $t('assignedUser.title') }}</h2>
                        <div class="flex flex-col gap-2">
                            <label class="label truncate text-[#385660]" :title="$t('assignedUser.label')">{{
                                $t('assignedUser.label') }}</label>
                            <div
                                class="input-container shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] flex items-center border border-[#3A5762] rounded-lg px-3">
                                <input
                                    class="input truncate flex-1 py-2 h-10 text-sm border-none outline-none text-[#7CADB9] transition-all duration-300 whitespace-nowrap overflow-hidden text-ellipsis cursor-help"
                                    :placeholder="$t('assignedUser.placeholder')"
                                    :value="assignedUserName || formData.assigned_to || ''" readonly
                                    style="--placeholder-color: #25B0D7; background-color: transparent; color: #7CADB9;" />
                                <button @click="openUserSearchModal"
                                    class="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200"
                                    :title="$t('requestDetailAdmin.actions.editAssigned')">
                                    <EditIcon class="w-4 h-4 text-[#385660] hover:text-[#2AB4D9]" />
                                </button>
                            </div>
                        </div>
                    </div> -->

                    <!-- MODAL: Búsqueda de usuarios (duplicado para mantener funcionalidad) -->
                    <div v-if="showUserSearchModal"
                        class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                        <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
                            <!-- Header -->
                            <div class="flex items-center justify-between p-6 border-b">
                                <h3 class="text-lg font-semibold text-[#385660]">{{
                                    $t('requestDetailAdmin.modalUserSearch.title') }}</h3>
                                <button @click="closeUserSearchModal"
                                    class="text-gray-400 hover:text-gray-600 transition-colors">
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>

                            <!-- Search Input -->
                            <div class="p-6 border-b">
                                <div class="relative">
                                    <input v-model="userSearchQuery" @input="searchUsers" type="text"
                                        :placeholder="$t('requestDetailAdmin.modalUserSearch.searchPlaceholder')"
                                        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent" />
                                    <div v-if="isSearchingUsers"
                                        class="absolute right-3 top-1/2 transform -translate-y-1/2">
                                        <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- User List -->
                            <div class="flex-1 overflow-y-auto p-6">
                                <div v-if="isSearchingUsers && !searchedUsers.length"
                                    class="text-center py-8 text-gray-500">
                                    {{ $t('requestDetailAdmin.modalUserSearch.searching') }}
                                </div>
                                <div v-else-if="!isSearchingUsers && !searchedUsers.length && userSearchQuery"
                                    class="text-center py-8 text-gray-500">
                                    {{ $t('requestDetailAdmin.modalUserSearch.noResults') }}
                                </div>
                                <div v-else-if="!userSearchQuery" class="text-center py-8 text-gray-500">
                                    {{ $t('requestDetailAdmin.modalUserSearch.startTyping') }}
                                </div>
                                <div v-else class="space-y-2">
                                    <button v-for="user in searchedUsers" :key="user.id" @click="selectUser(user)"
                                        class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors">
                                        <div class="font-medium text-[#385660]">{{ user.name }}</div>
                                        <div v-if="user.email" class="text-sm text-gray-500">{{ user.email }}</div>
                                    </button>
                                </div>
                            </div>

                            <!-- Footer -->
                            <div class="p-6 border-t flex justify-end space-x-3">
                                <button @click="closeUserSearchModal"
                                    class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                                    {{ $t('requestDetailAdmin.modalUserSearch.cancel') }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col gap-4" :class="{ 'opacity-60': consentsLocked }">
                        <!-- Consentimientos de la solicitud original: se muestran
                             marcados, bloqueados y con su fecha (ADS-0127). -->
                        <p v-if="consentsLocked" class="text-xs text-gray-500">{{ $t('conditionsCheck.locked') }}</p>
                        <!-- CHECK 1 (obligatorio): condiciones generales y privacidad -->
                        <div class="flex flex-col gap-1">
                            <label class="flex items-start gap-2" :class="consentsLocked ? 'cursor-not-allowed' : 'cursor-pointer'">
                                <input
                                    type="checkbox"
                                    :checked="consentChecked('terms')"
                                    @change="event => setConsent('terms', event.target.checked)"
                                    :disabled="consentsLocked"
                                    data-testid="consent-terms"
                                    class="w-4 h-4 mt-1"
                                    :class="{ 'consent-locked': consentsLocked }"
                                />
                                <span class="text-sm" :class="consentsLocked ? 'text-gray-500' : 'text-[#385660]'">
                                    {{ $t('conditionsCheck.terms.label') }} <span class="mr-1" aria-hidden="true">*</span>
                                    <button type="button" class="text-[var(--c-primary)] underline"
                                        @click.prevent.stop="toggleReadMore('terms')">
                                        {{ showReadMore.terms ? $t('conditionsCheck.readLess') : $t('conditionsCheck.readMore') }}
                                    </button>
                                </span>
                            </label>
                            <div v-if="showReadMore.terms" class="pl-6 text-sm leading-relaxed text-[#385660] space-y-3">
                                <h3 class="font-semibold">{{ $t('conditionsCheck.terms.details.title') }}</h3>
                                <p>{{ $t('conditionsCheck.terms.details.intro') }}</p>
                                <section v-for="(section, sectionIndex) in $tm('conditionsCheck.terms.details.sections')"
                                    :key="sectionIndex" class="space-y-2">
                                    <h4 class="font-semibold">{{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.title`) }}</h4>
                                    <p v-if="section.contact">
                                        {{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.contact.before`) }}<a
                                            :href="`mailto:${$t(`conditionsCheck.terms.details.sections.${sectionIndex}.contact.email`)}`"
                                            class="text-[var(--c-primary)] underline">{{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.contact.email`) }}</a>{{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.contact.after`) }}
                                    </p>
                                    <p v-for="(_, paragraphIndex) in section.paragraphs || []" :key="paragraphIndex">
                                        {{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.paragraphs.${paragraphIndex}`) }}
                                    </p>
                                    <ul v-if="section.items?.length" class="list-disc space-y-1 pl-5">
                                        <li v-for="(_, itemIndex) in section.items" :key="itemIndex">
                                            {{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.items.${itemIndex}`) }}
                                        </li>
                                    </ul>
                                    <p v-if="section.after">{{ $t(`conditionsCheck.terms.details.sections.${sectionIndex}.after`) }}</p>
                                </section>
                            </div>
                            <p v-if="consentsLocked" class="pl-6 text-xs text-gray-500">{{ consentLabel('terms') }}</p>
                            <span v-if="isSubmitted && !acceptConditions && !consentsLocked" class="pl-6 text-red-500 text-sm">
                                {{ $t('conditionsCheck.errors.required') }}
                            </span>
                        </div>

                        <!-- CHECK 2 (obligatorio): tratamiento y comunicación de datos -->
                        <div class="flex flex-col gap-1">
                            <label class="flex items-start gap-2" :class="consentsLocked ? 'cursor-not-allowed' : 'cursor-pointer'">
                                <input
                                    type="checkbox"
                                    :checked="consentChecked('dataProcessing')"
                                    @change="event => setConsent('dataProcessing', event.target.checked)"
                                    :disabled="consentsLocked"
                                    data-testid="consent-data-processing"
                                    class="w-4 h-4 mt-1"
                                    :class="{ 'consent-locked': consentsLocked }"
                                />
                                <span class="text-sm" :class="consentsLocked ? 'text-gray-500' : 'text-[#385660]'">
                                    {{ $t('conditionsCheck.dataProcessing.label') }} <span class="mr-1" aria-hidden="true">*</span>
                                    <button type="button" class="text-[var(--c-primary)] underline"
                                        @click.prevent.stop="toggleReadMore('dataProcessing')">
                                        {{ showReadMore.dataProcessing ? $t('conditionsCheck.readLess') : $t('conditionsCheck.dataProcessing.readMore') }}
                                    </button>
                                </span>
                            </label>
                            <div v-if="showReadMore.dataProcessing" class="pl-6 text-sm leading-relaxed text-[#385660] space-y-3">
                                <p v-for="(_, paragraphIndex) in $tm('conditionsCheck.dataProcessing.details')" :key="paragraphIndex">
                                    {{ $t(`conditionsCheck.dataProcessing.details.${paragraphIndex}`) }}
                                </p>
                            </div>
                            <p v-if="consentsLocked" class="pl-6 text-xs text-gray-500">{{ consentLabel('dataProcessing') }}</p>
                            <span v-if="isSubmitted && !acceptDataProcessing && !consentsLocked" class="pl-6 text-red-500 text-sm">
                                {{ $t('conditionsCheck.errors.required') }}
                            </span>
                        </div>

                        <!-- CHECK 3 (opcional): comunicaciones comerciales -->
                        <div class="flex flex-col gap-1">
                            <label class="flex items-start gap-2" :class="consentsLocked ? 'cursor-not-allowed' : 'cursor-pointer'">
                                <input
                                    type="checkbox"
                                    :checked="consentChecked('commercial')"
                                    @change="event => setConsent('commercial', event.target.checked)"
                                    :disabled="consentsLocked"
                                    data-testid="consent-commercial"
                                    class="w-4 h-4 mt-1"
                                    :class="{ 'consent-locked': consentsLocked }"
                                />
                                <span class="text-sm" :class="consentsLocked ? 'text-gray-500' : 'text-[#385660]'">
                                    {{ $t('conditionsCheck.commercial.label') }}
                                    <button type="button" class="text-[var(--c-primary)] underline"
                                        @click.prevent.stop="toggleReadMore('commercial')">
                                        {{ showReadMore.commercial ? $t('conditionsCheck.readLess') : $t('conditionsCheck.readMore') }}
                                    </button>
                                </span>
                            </label>
                            <p v-if="showReadMore.commercial" class="pl-6 text-xs leading-4 text-gray-500">
                                {{ $t('conditionsCheck.commercial.details') }}
                            </p>
                            <p v-if="consentsLocked" class="pl-6 text-xs text-gray-500">{{ consentLabel('commercial') }}</p>
                        </div>
                    </div>
                    
                    <div v-if="!isEditMode && !canPickClientAccount && supportsContractImprovement(formType)" class="rounded-xl border border-gray-200 bg-white p-4" data-testid="contract-improvement-create">
                        <label class="flex cursor-pointer items-start gap-3 text-sm font-semibold text-[#385660]">
                            <input v-model="contractImprovementAccepted" type="checkbox" class="mt-0.5 h-5 w-5 shrink-0 accent-[#25B0D7]" data-testid="contract-improvement-create-check" />
                            <span>{{ $t('contractImprovement.check') }}. {{ $t('contractImprovement.checkHelp') }}</span>
                        </label>
                        <div v-if="contractImprovementAccepted" class="mt-4 grid gap-4 border-t border-gray-200 pt-4 sm:grid-cols-2">
                            <div class="text-sm text-[#385660]">
                                <span class="block font-medium">{{ $t('contractImprovement.documents.dni') }} *</span>
                                <input ref="contractImprovementDniInput" type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" class="hidden" :aria-label="$t('contractImprovement.documents.dni')" data-testid="contract-improvement-create-dni" @change="contractImprovementDni = $event.target.files?.[0] || null" />
                                <button type="button" class="mt-2 inline-flex cursor-pointer rounded-lg border border-[#147D98] bg-white px-3 py-2 text-sm font-semibold text-[#147D98] hover:bg-[#EAF8FB]" @click="contractImprovementDniInput?.click()">
                                    {{ $t('contractImprovement.chooseFile') }}
                                </button>
                                <span class="mt-2 block break-all text-sm text-gray-500">{{ contractImprovementDni?.name || $t('contractImprovement.noFile') }}</span>
                            </div>
                            <div class="text-sm text-[#385660]">
                                <span class="block font-medium">{{ $t('contractImprovement.documents.bank') }}</span>
                                <input ref="contractImprovementBankInput" type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" class="hidden" :aria-label="$t('contractImprovement.documents.bank')" data-testid="contract-improvement-create-bank" @change="contractImprovementBank = $event.target.files?.[0] || null" />
                                <button type="button" class="mt-2 inline-flex cursor-pointer rounded-lg border border-[#147D98] bg-white px-3 py-2 text-sm font-semibold text-[#147D98] hover:bg-[#EAF8FB]" @click="contractImprovementBankInput?.click()">
                                    {{ $t('contractImprovement.chooseFile') }}
                                </button>
                                <span class="mt-2 block break-all text-sm text-gray-500">{{ contractImprovementBank?.name || $t('contractImprovement.noFile') }}</span>
                            </div>
                            <label class="text-sm text-[#385660] sm:col-span-2">
                                <span class="block font-medium">{{ $t('contractImprovement.ibanLabel') }}</span>
                                <input v-model="contractImprovementIban" type="text" autocomplete="off" class="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2" :placeholder="$t('contractImprovement.ibanPlaceholder')" data-testid="contract-improvement-create-iban" />
                                <span class="mt-1 block text-xs text-gray-500">{{ $t('contractImprovement.ibanHelp') }}</span>
                            </label>
                            <p class="text-xs text-gray-500 sm:col-span-2">{{ $t('contractImprovement.formats') }}</p>
                        </div>
                        <p v-if="contractImprovementError" class="mt-3 text-sm text-red-700" role="alert">{{ contractImprovementError }}</p>
                    </div>

                    <!-- SECCIÓN: Botones de envío -->
                    <div class="flex flex-col gap-4">
                        <ButtonWhiteVue :disabled="isSubmitting" @click="() => {
                            console.log('🔍 Button clicked, isEditMode:', isEditMode.value);
                            isEditMode.value ? submitFormUpdate() : submitForm();
                        }" class="w-full lg:w-auto" bgColor="bg-[#2AB4D9]" hoverBgColor="hover:bg-[#3ac3e9]"
                            textColor="text-white">
                            {{ isEditMode ? $t('formSubmit.buttons.update') : $t('formSubmit.buttons.submit') }}
                        </ButtonWhiteVue>

                        <ButtonWhiteVue @click="cancelForm()" class="w-full lg:w-auto" bgColor="bg-[#E0E0E0]"
                            hoverBgColor="hover:bg-[#E0E0E0]" textColor="text-black">
                            {{ $t('formSubmit.buttons.cancel') }}
                        </ButtonWhiteVue>

                    </div>
                    <!-- SECCIÓN: Mensaje informativo -->
                    <div class="flex items-start gap-2 rounded-lg text-sm text-[var(--c-primary)]">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20A10 10 0 0012 2z" />
                        </svg>
                        <div class="flex flex-col gap-4" >
                            <span>{{ $t('form.info.afterSave.line1') }}</span>
                            <span>{{ $t('form.info.afterSave.line2') }}</span>
                        </div>
                    </div>

                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
// ===================================================================
// IMPORTS Y CONFIGURACIÓN INICIAL
// ===================================================================
import { ref, computed, watch, onMounted, nextTick, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

// Componentes importados
import LightIcon from '@/assets/svg/Light.vue';
import GasIcon from '@/assets/svg/gas.vue';
import AmbosIcon from '@/assets/svg/Ambos.vue';
import titlePrimary from "@/components/title/title-primary.vue";
import ButtonWhiteVue from '@/components/button/ButtonWhite.vue';
import inputPrimaryVue from '@/components/inputs/input-primary.vue';
import HolderTelephoneField from '@/components/request/HolderTelephoneField.vue';
import HolderOptionalFields from '@/components/forms/HolderOptionalFields.vue';
import { getRequestDocumentTypeOptions } from '@/constants/requestDocumentTypes';
import { hasAnyRole } from '@/services/userRoles';
import { allowsOtherAction } from '@/services/supplyRequestOptions';
import { requiresSupplyAddressForType, validateSupplyAddress } from '@/services/requestSupplyAddress';
import { fetchAccountDetailWithKind, accountTypeLabel, accountHasBothTypes } from '@/services/clientAccount';
import { isValidIban, normalizeIban, supportsContractImprovement } from '@/services/contractImprovement';
// import EditIcon from '@/assets/svg/EditIcon.vue';

// ===================================================================
// CONFIGURACIÓN Y DATOS ESTÁTICOS
// ===================================================================
const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const documentTypeOptions = computed(() => getRequestDocumentTypeOptions(t));

// Opciones de tipos de suministro
const supplyOptions = [
    { translationKey: 'light', value: 'luz', icon: LightIcon },
    { translationKey: 'gas', value: 'gas', icon: GasIcon },
    { translationKey: 'both', value: 'ambos', icon: AmbosIcon },
];

// Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
// const REQUIRED_TELEPHONE_FORM_TYPES = ['supplies', 'change_ownership', 'change_supplier', 'account_change', 'invoice', 'other_type'];
const REQUIRED_TELEPHONE_FORM_TYPES = ['supplies', 'change_ownership', 'account_change', 'invoice', 'other_type'];

// Campos que se pueden autocompletar
const normalizeSupplyType = (typeValue) => {
    const normalized = String(typeValue || '').toLowerCase();

    if (normalized === 'light' || normalized === 'luz') return 'luz';
    if (normalized === 'gas') return 'gas';
    if (normalized === 'both' || normalized === 'ambos') return 'ambos';

    return '';
};

const firstFilledValue = (...values) => values.find((value) => {
    if (value === null || value === undefined) return false;
    return String(value).trim() !== '';
}) ?? '';

const postalCodeFromText = (text) => {
    const match = String(text || '').match(/\b\d{5}\b/);
    return match ? match[0] : '';
};

const municipalityFromText = (text) => {
    const normalizedText = String(text || '').trim();
    const afterPostalCode = normalizedText.match(/\b\d{5}\s+([A-Za-zÀ-ÿ.' -]+)$/u);

    if (afterPostalCode) {
        return afterPostalCode[1].trim();
    }

    const knownCity = normalizedText.match(/\b(Barcelona)\b/i);
    return knownCity ? knownCity[1].charAt(0).toUpperCase() + knownCity[1].slice(1).toLowerCase() : '';
};

const getSuggestionSupplies = (suggestion) => {
    if (!suggestion || typeof suggestion !== 'object') return [];

    const candidates = [
        suggestion.supplies,
        suggestion.supplies_by_light,
        suggestion.supplies_by_gas,
        suggestion.suppliesByLight,
        suggestion.suppliesByGas,
    ];

    return candidates.flatMap((candidate) => {
        if (Array.isArray(candidate)) return candidate;
        if (candidate && typeof candidate === 'object') return [candidate];
        return [];
    });
};

const resolveSuggestionAddress = (suggestion) => firstFilledValue(
    suggestion?.address,
    suggestion?.supply_address,
    suggestion?.property?.address,
    suggestion?.user_address
);

const resolveSuggestionPostalCode = (suggestion) => firstFilledValue(
    suggestion?.postal_code,
    suggestion?.zip,
    suggestion?.property?.postal_code,
    ...getSuggestionSupplies(suggestion).map((supply) => supply?.postal_code),
    postalCodeFromText(suggestion?.supply_address),
    postalCodeFromText(suggestion?.address),
    postalCodeFromText(suggestion?.property?.address),
    postalCodeFromText(suggestion?.user_address)
);

const resolveSuggestionMunicipality = (suggestion) => firstFilledValue(
    suggestion?.municipality,
    suggestion?.city,
    suggestion?.property?.municipality,
    suggestion?.property?.city,
    suggestion?.propietario?.city,
    suggestion?.manager?.city,
    suggestion?.assigned_to?.city,
    municipalityFromText(suggestion?.supply_address),
    municipalityFromText(suggestion?.address),
    municipalityFromText(suggestion?.property?.address),
    municipalityFromText(suggestion?.user_address)
);

const normalizeAddressSuggestion = (suggestion) => {
    if (!suggestion || typeof suggestion !== 'object') return suggestion;

    const municipality = resolveSuggestionMunicipality(suggestion);

    return {
        ...suggestion,
        address: resolveSuggestionAddress(suggestion),
        postal_code: resolveSuggestionPostalCode(suggestion),
        municipality,
        property: {
            ...(suggestion.property || {}),
            address: firstFilledValue(suggestion?.property?.address, suggestion?.user_address),
            postal_code: firstFilledValue(suggestion?.property?.postal_code, suggestion?.postal_code),
            municipality,
        },
    };
};

// ===================================================================
// ESTADO REACTIVO DEL FORMULARIO
// ===================================================================
const formData = ref({
    municipality: '', supply_address: '', postal_code: '', user_address: '', correspondence_population: '',
    contact_name: '', contact_surname: '', contact_person: '', dni_nie: '', email: '', telephone: '', telephone_unavailable: false, iban: '', observations: '',
    cups_light: '', cups_gas: '', light_meter_reading: '', gas_meter_reading: '', type: '', status: 'created',
    includes_water: false,
    manager: '', assigned_to: '', client_account_id: '',
    other_action: '',
    // Origen de la solicitud cuando se abre desde un CUPS o un inmueble (ADS-0125)
    property_id: null, supply_light_id: null, supply_gas_id: null
});
// request_role: selected role when user has both 'vertical' and 'horizontal'
formData.value.request_role = '';

// Estado del formulario y validaciones
const selectedOption = ref(null);
// Suministro desde el que se abre el formulario (ADS-0125): fija la energía y
// vincula la solicitud con el CUPS, su inmueble y su cuenta.
const originSupply = ref(null);
const isEnergyLocked = computed(() => !!originSupply.value);
// Un gas no puede pedir potencias: "Otro" oculta esa acción.
const allowsPowerModification = computed(() => allowsOtherAction('modificar_potencia', originSupply.value?.type));
const isSubmitted = ref(false);
const isSubmitting = ref(false);
const contractImprovementAccepted = ref(false);
const contractImprovementDni = ref(null);
const contractImprovementDniInput = ref(null);
const contractImprovementBank = ref(null);
const contractImprovementBankInput = ref(null);
const contractImprovementIban = ref('');
const contractImprovementError = ref('');

// «No dispongo» no se ofrece de entrada: aparece recién cuando se intenta
// guardar sin haber puesto el teléfono del titular. Una vez visible se queda,
// para poder marcarlo sin que desaparezca al limpiarse el error, y también se
// muestra al abrir una solicitud que ya venía con la excepción marcada.
const telephoneUnavailableOffered = ref(false);
const showsTelephoneUnavailable = computed(
    () => telephoneUnavailableOffered.value || formData.value.telephone_unavailable
);
const isEditing = ref(false);

// Al modificar una solicitud se respeta lo que el cliente indicó del teléfono
// del titular (el número o «No dispongo»): se muestra en gris, como los
// consentimientos, y no viaja a la API. Solo se desbloquea a propósito, cuando
// el cliente facilitó un número nuevo.
const telephoneAnsweredOnCreate = ref(false);
const telephoneUnlockedForEdit = ref(false);
const telephoneLocked = computed(
    () => isEditing.value && telephoneAnsweredOnCreate.value && !telephoneUnlockedForEdit.value
);
const unlockTelephone = () => {
    telephoneUnlockedForEdit.value = true;
};
const errors = ref([]);
const fieldErrors = ref({});
const isDifferentAddress = ref(false);
const showOnlyAssigned = ref(false);

// Estados de error específicos
const hasSupplyTypeError = ref(false);
const hasLightError = ref(false);
const hasGasError = ref(false);
const hasBankError = ref(false);
const hasOtherActionError = ref(false);
const hasObservationError = ref(false);
const hasConditionsError = ref(false);
const hasOwnerError = ref({ name: false, dni: false, email: false, telephone: false });
const hasAddressError = ref({ supply: false, postal: false, correspondence: false, municipality: false, correspondencePopulation: false });
const hasTelephoneInvalidCharacters = ref(false);
const acceptConditions = ref(false);
const acceptDataProcessing = ref(false);
const acceptCommercialComms = ref(false);

/**
 * Consentimientos de la solicitud que se abre para modificar (ADS-0127).
 *
 * La solicitud guarda la fecha en que se dio cada uno. Al modificarla se
 * muestran tal como se dieron —marcados, bloqueados y en gris— y no viajan a la
 * API: el consentimiento original y su fecha no se tocan.
 */
const CONSENT_DATE_FIELDS = {
    terms: 'accepted_terms_at',
    dataProcessing: 'accepted_data_processing_at',
    commercial: 'accepted_commercial_comms_at',
};
const storedConsents = computed(() => Object.fromEntries(
    Object.entries(CONSENT_DATE_FIELDS).map(([key, field]) => [key, formData.value?.[field] || null])
));
const consentsLocked = computed(() => Object.values(storedConsents.value).some(Boolean));
const CONSENT_MODELS = { terms: acceptConditions, dataProcessing: acceptDataProcessing, commercial: acceptCommercialComms };
// Bloqueados, los checks muestran lo que se aceptó en su día, no lo que marque
// quien edita; en un alta son los del formulario.
const consentChecked = (key) => (consentsLocked.value ? Boolean(storedConsents.value[key]) : CONSENT_MODELS[key].value);
const setConsent = (key, value) => {
    if (!consentsLocked.value) CONSENT_MODELS[key].value = value;
};
const showReadMore = ref({ terms: false, dataProcessing: false, commercial: false });

const toggleReadMore = (key) => {
    showReadMore.value[key] = !showReadMore.value[key];
};

// ===================================================================
// AUTOCOMPLETADO DE DIRECCIONES
// ===================================================================
const showAddressSearch = ref(false);
const addressSuggestions = ref([]);
const addressSearchContainer = ref(null);
const cupsLightSearchContainer = ref(null);
const cupsGasSearchContainer = ref(null);
const showCupsSearch = ref({ light: false, gas: false });
const cupsSuggestions = ref({ light: [], gas: [] });
const isSearchingCups = ref({ light: false, gas: false });
let addressSearchTimeout = null;
let cupsSearchTimeouts = { light: null, gas: null };

function closeAutocompleteDropdowns() {
    showAddressSearch.value = false;
    addressSuggestions.value = [];
    showCupsSearch.value = { light: false, gas: false };
    cupsSuggestions.value = { light: [], gas: [] };
}

function selectAddressSuggestion(suggestion) {
    const normalizedSuggestion = normalizeAddressSuggestion(suggestion);
    closeAutocompleteDropdowns();
    doAutocomplete(normalizedSuggestion);
}

function shouldPrefillOwnerFields() {
    // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
    // return formType.value !== 'change_ownership' && formType.value !== 'change_supplier';
    return formType.value !== 'change_ownership';
}

function shouldPrefillAddressFields() {
    const hasPrefillId = !!route.query?.id;
    const isRestrictedType = formType.value === 'invoice' || formType.value === 'account_change';
    return !(isRestrictedType && hasPrefillId);
}

function shouldPrefillAccountChangeIban() {
    const hasPrefillId = !!route.query?.id;
    return !(formType.value === 'account_change' && hasPrefillId);
}

function shouldPrefillCupsForSupplyType(supplyType) {
    const normalizedSupplyType = normalizeSupplyType(supplyType);
    const currentSelection = normalizeSupplyType(selectedOption.value);

    if (!normalizedSupplyType) return false;
    if (currentSelection && currentSelection !== 'ambos' && currentSelection !== normalizedSupplyType) return false;

    const cupsKey = normalizedSupplyType === 'gas' ? 'gas' : 'light';
    return !sabeCUPS.value[cupsKey];
}

// Autocompleta solo la dirección, el CP y el municipio del suministro.
// Titular, correspondencia y observaciones son del nuevo titular y se rellenan a mano.
function doAutocomplete(suggestion) {
    const normalizedSuggestion = normalizeAddressSuggestion(suggestion);
    const normalizedSuggestionType = normalizeSupplyType(normalizedSuggestion?.type);

    formData.value.supply_address = normalizedSuggestion.address || '';
    formData.value.postal_code = normalizedSuggestion.postal_code || '';
    formData.value.municipality = normalizedSuggestion.municipality || '';
    // Misma sincronización que al escribir la dirección a mano
    if (!isDifferentAddress.value) {
        formData.value.user_address = formData.value.supply_address;
    }
    if (!formData.value.type) {
        formData.value.type = normalizedSuggestionType || '';
    }

    if (!selectedOption.value && normalizedSuggestionType) {
        selectedOption.value = normalizedSuggestionType;
    }

    if (normalizedSuggestion.cups) {
        if (normalizedSuggestionType === 'gas' && shouldPrefillCupsForSupplyType('gas')) {
            formData.value.cups_gas = normalizedSuggestion.cups;
        } else if (normalizedSuggestionType === 'luz' && shouldPrefillCupsForSupplyType('luz')) {
            formData.value.cups_light = normalizedSuggestion.cups;
        }
    }

    syncCupsWithSupplySelection();

    addressSuggestions.value = [];
    showAddressSearch.value = false;
}

// ===================================================================
// BÚSQUEDA DE DIRECCIONES
// ===================================================================
const onSupplyAddressInput = async (value) => {
    formData.value.supply_address = value;
    // Si la dirección de correspondencia no es diferente, mantenerla sincronizada
    if (!isDifferentAddress.value) {
        formData.value.user_address = value || '';
    }
    if (!value || value.trim() === '') {
        addressSuggestions.value = [];
        showAddressSearch.value = false;
        // También limpiar la dirección de usuario cuando esté sincronizada
        if (!isDifferentAddress.value) formData.value.user_address = '';
        return;
    }

    if (addressSearchTimeout) clearTimeout(addressSearchTimeout);
    addressSearchTimeout = setTimeout(async () => {
        try {
            const apiUrl = import.meta.env.VITE_API_URL || '';
            const token = localStorage.getItem('token');
            const response = await axios.get(`${apiUrl}/supply/user/search`, {
                params: { query: value, search_by: 'address', type: 'both' },
                headers: { Authorization: token ? `Bearer ${token}` : '' }
            });

            if (response.data?.value?.data && Array.isArray(response.data.value.data)) {
                addressSuggestions.value = response.data.value.data.map(normalizeAddressSuggestion);
                showAddressSearch.value = true;
            } else {
                addressSuggestions.value = [];
                showAddressSearch.value = false;
            }
        } catch (err) {
            console.error('Error fetching address suggestions:', err);
            addressSuggestions.value = [];
            showAddressSearch.value = false;
        }
    }, 300);
};

const handleClickOutside = (event) => {
    nextTick(() => {
        if (addressSearchContainer.value && !addressSearchContainer.value.contains(event.target)) {
            showAddressSearch.value = false;
        }
        if (cupsLightSearchContainer.value && !cupsLightSearchContainer.value.contains(event.target)) {
            showCupsSearch.value.light = false;
        }
        if (cupsGasSearchContainer.value && !cupsGasSearchContainer.value.contains(event.target)) {
            showCupsSearch.value.gas = false;
        }
    });
};

// Toggle para el checkbox "Dirección diferente". Si se desmarca, copiar la dirección de suministro.
const toggleDifferentAddress = () => {
    isDifferentAddress.value = !isDifferentAddress.value;
    if (!isDifferentAddress.value) {
        formData.value.user_address = formData.value.supply_address || '';
    }
};

// ===================================================================
// ESTADO DE ARCHIVOS Y CUPS
// ===================================================================
const fileInput = ref(null);
const uploadedFiles = ref([]);
const fileError = ref('');
const fileErrorKey = ref('');
const documentalTypeError = ref(false);
const sabeCUPS = ref({ light: false, gas: false });

// ===================================================================
// ESTADO PARA BÚSQUEDA DE USUARIOS
// ===================================================================
const showUserSearchModal = ref(false);
const userSearchQuery = ref('');
const searchedUsers = ref([]);
const isSearchingUsers = ref(false);
const searchTimeout = ref(null);
const assignedUserName = ref('');
const prefilledUserName = ref('');

// ===================================================================
// ESTADO PARA BÚSQUEDA DE CUENTAS CLIENTE (ADS crea en nombre de un cliente)
// ===================================================================
const showAccountSearchModal = ref(false);
const accountSearchQuery = ref('');
const searchedAccounts = ref([]);
const isSearchingAccounts = ref(false);
const accountSearchTimeout = ref(null);
// Cuenta cliente elegida: { id, name, email, type_label, types }
const selectedAccount = ref(null);
const hasClientAccountError = ref(false);

// ===================================================================
// VALIDACIONES DE COMPONENTES
// ===================================================================
const componentValidations = ref({
    supplysType: true,
    knowCups: true,
    observation: true,
    ownerDate: true,
    supplysDate: true,
    fileUpload: true,
    bankAccount: true,
    addressCp: true,
    requestRole: true,
});

// ===================================================================
// INICIALIZACIÓN Y EVENTOS LIFECYCLE
// ===================================================================
onMounted(async () => {
    // Configurar event listeners
    document.addEventListener('click', handleClickOutside);

    // Cargar datos si estamos en modo edición
    await loadFormData();
});

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside);
});

// Función para cargar datos de propiedad por ID y autocompletar campos relacionados
const fetchPropertyById = async (propertyId) => {
    if (!propertyId) {
        return;
    }

    try {
        const response = await axios.get(
            `${import.meta.env.VITE_API_URL}/supply/get/${propertyId}`,
            {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }
        );

        const propertyData = response.data?.value;
        if (!propertyData) {
            return;
        }

        const propertyInfo = propertyData.property || {};
        const ownerInfo = propertyInfo.propietario || propertyData.propietario || {};

        const supplies = Array.isArray(propertyData.supplies)
            ? propertyData.supplies
            : (propertyData?.cups ? [propertyData] : []);

        const lightSupply = supplies.find((s) => normalizeSupplyType(s?.type) === 'luz') || null;
        const gasSupply = supplies.find((s) => normalizeSupplyType(s?.type) === 'gas') || null;

        if (shouldPrefillAddressFields()) {
            formData.value.supply_address = propertyData.address || propertyInfo.address || formData.value.supply_address;
            formData.value.postal_code = propertyData.postal_code || propertyInfo.postal_code || formData.value.postal_code;
            formData.value.municipality = propertyData.municipality || propertyInfo.municipality || formData.value.municipality;
        } else {
            formData.value.supply_address = '';
            formData.value.postal_code = '';
            formData.value.municipality = '';
        }
        formData.value.observations = propertyData.observations || propertyData.comments || propertyInfo.comments || formData.value.observations;
        formData.value.includes_water = propertyData.includes_water ?? propertyInfo.includes_water ?? formData.value.includes_water;

        if (shouldPrefillOwnerFields()) {
            // Nombre y documento del titular solo se autocompletan en el alta de
            // suministro, donde son obligatorios. En las demás tipologías son
            // opcionales y los informa el cliente si los conoce (ADS-0171).
            if (!showsOptionalHolderFields.value) {
                formData.value.contact_name = ownerInfo.name || propertyInfo.name || formData.value.contact_name;
                formData.value.dni_nie = ownerInfo.dni_nie || ownerInfo.cif || propertyInfo.cif || propertyData.cif || formData.value.dni_nie;
            }
            formData.value.email = ownerInfo.email || formData.value.email;
            // El teléfono no se autocompleta (16/09/2026): el que tienen la cuenta
            // y la finca es el del administrador, no el del titular del suministro.
            // Lo informa quien tramita, o marca "No dispongo".
            formData.value.iban = propertyData.iban || propertyInfo.iban || ownerInfo.iban || formData.value.iban;
        } else {
            formData.value.contact_name = '';
            formData.value.dni_nie = '';
            formData.value.email = '';
            formData.value.telephone = '';
            formData.value.iban = '';
        }

        if (!shouldPrefillAccountChangeIban()) {
            formData.value.iban = '';
        }
        formData.value.user_address = propertyInfo.address || propertyData.address || formData.value.user_address;
        isDifferentAddress.value = false;

        // Extraer username del propietario si existe (para superadmin)
        const propertyOwner = ownerInfo || propertyData.propietario || propertyInfo.propietario || null;
        if (propertyOwner) {
            assignedUserName.value = propertyOwner.username || propertyOwner.user_name || propertyOwner.user || propertyOwner.login || assignedUserName.value || '';
        }

        if (lightSupply?.cups && shouldPrefillCupsForSupplyType('luz')) {
            formData.value.cups_light = lightSupply.cups;
        }

        if (gasSupply?.cups && shouldPrefillCupsForSupplyType('gas')) {
            formData.value.cups_gas = gasSupply.cups;
        }

        if (!selectedOption.value && lightSupply && gasSupply) {
            selectedOption.value = 'ambos';
            formData.value.type = 'ambos';
        } else if (!selectedOption.value) {
            const normalizedType = normalizeSupplyType(lightSupply?.type || gasSupply?.type || propertyData?.type);
            if (normalizedType) {
                selectedOption.value = normalizedType;
                formData.value.type = normalizedType;
            }
        }

        syncCupsWithSupplySelection();

        return propertyData;
    } catch (error) {
        console.error('Error loading property detail for form:', error);
    }
};

const applySupplyOrigin = async (supplyId) => {
    const supply = await fetchPropertyById(supplyId);
    const energy = normalizeSupplyType(supply?.type);
    if (!supply || (energy !== 'luz' && energy !== 'gas')) {
        return;
    }

    originSupply.value = { id: supply.id, type: energy === 'gas' ? 'gas' : 'light', cups: supply.cups || '' };
    selectedOption.value = energy;
    formData.value.type = energy;
    formData.value.supply_light_id = energy === 'luz' ? supply.id : null;
    formData.value.supply_gas_id = energy === 'gas' ? supply.id : null;
    formData.value.property_id = supply.property_id ?? supply.property?.id ?? null;
    if (supply.cups) {
        formData.value[energy === 'gas' ? 'cups_gas' : 'cups_light'] = supply.cups;
    }
    syncCupsWithSupplySelection(energy);
    if (!allowsPowerModification.value && formData.value.other_action === 'modificar_potencia') {
        formData.value.other_action = '';
    }

    // ADS tramita a nombre de la cuenta dueña del inmueble; para el cliente la
    // cuenta la fija la API a partir del suministro.
    const accountId = supply.property?.propietario_id;
    if (accountId && canPickClientAccount.value && !formData.value.client_account_id) {
        await applyClientAccountId(accountId);
    }
};

const loadFormData = async () => {
    // Prefill desde query params
    const q = route.query || {};
    const forceEditMode = q.edit === '1' || q.edit === 'true';

    if (q.user_name) {
        prefilledUserName.value = String(q.user_name);
    }
    // El formulario se abre desde el detalle de una cuenta o desde una fila
    // (comunidad, suministro) cuyo propietario es una cuenta cliente. Ese id
    // llega como `account_id` o, en los enlaces antiguos, como `user_id`.
    if (q.account_id) {
        await applyClientAccountId(q.account_id);
    } else if (q.user_id) {
        await applyPrefilledClientId(q.user_id);
    }

    const editData = localStorage.getItem('editRequestData');
    const prefillPropertyId = q.id ? String(q.id) : null;

    const onlyAssigned = route.query?.only_assigned;
    if (onlyAssigned === '1' || onlyAssigned === 'true') {
        showOnlyAssigned.value = true;
    }

    if (editData) {
        try {
            const parsedData = JSON.parse(editData);
            if ((parsedData.isEditing || forceEditMode) && parsedData.type === formType.value) {
                isEditing.value = true;
                formData.value = { ...formData.value, ...parsedData, type: parsedData.type || formType.value };
                formData.value.telephone_unavailable = parsedData.telephone_unavailable === true;
                telephoneAnsweredOnCreate.value = formData.value.telephone_unavailable
                    || !!String(parsedData.telephone || '').trim();

                // Auto-seleccionar tipo de suministro basándose en CUPS
                if (parsedData.cups_light && parsedData.cups_gas) {
                    formData.value.type = 'ambos';
                    selectedOption.value = 'ambos';
                } else if (parsedData.cups_light && !parsedData.cups_gas) {
                    formData.value.type = 'luz';
                    selectedOption.value = 'luz';
                } else if (parsedData.cups_gas && !parsedData.cups_light) {
                    formData.value.type = 'gas';
                    selectedOption.value = 'gas';
                }

                localStorage.removeItem('editRequestData');
                // Si el edit payload contiene información del propietario, extraer username
                const parsedOwner = parsedData.propietario || parsedData.property?.propietario || parsedData.owner || null;
                if (parsedOwner) {
                    assignedUserName.value = parsedOwner.username || parsedOwner.user_name || parsedOwner.user || parsedOwner.login || assignedUserName.value || '';
                }
            }
        } catch (error) {
            console.error('Error parsing edit data:', error);
        }
    } else {
        formData.value.status = "created";

        if (q.supply_id) {
            await applySupplyOrigin(q.supply_id);
        } else if (prefillPropertyId) {
            await fetchPropertyById(prefillPropertyId);
        }
    }
};

// ===================================================================
// COMPUTED PROPERTIES Y MÉTODOS PRINCIPALES
// ===================================================================
const formType = computed(() => route.params.type || 'supplies');
const requiresSupplyAddress = computed(() => requiresSupplyAddressForType(formType.value));
// Nombre, apellidos y documento del titular, opcionales, en las tipologías que
// no los piden como obligatorios (ADS-0171). El alta de suministro y el cambio
// de titular ya los recogen en su propio bloque.
const showsOptionalHolderFields = computed(
    () => formType.value !== 'supplies' && formType.value !== 'change_ownership'
);
const showCupsFields = computed(() => selectedOption.value !== null);
const shouldShowLightInput = computed(() => ['luz', 'ambos'].includes(selectedOption.value));
const shouldShowGasInput = computed(() => ['gas', 'ambos'].includes(selectedOption.value));
// La lectura del contador sirve para separar el consumo del titular anterior
// del nuevo: solo se pide en cambio de titularidad (SOL-05).
// Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
// const METER_READING_FORM_TYPES = ['change_ownership', 'change_supplier'];
const METER_READING_FORM_TYPES = ['change_ownership'];
const showsMeterReadings = computed(() => METER_READING_FORM_TYPES.includes(formType.value));
const isEditMode = computed(() => {
    const queryEdit = route.query?.edit === '1' || route.query?.edit === 'true';
    return isEditing.value || queryEdit || !!formData.value.id;
});
const isSuperadmin = computed(() => localStorage.getItem('role') === 'superadmin');
// const requiresConditions = computed(() => ['supplies', 'change_ownership'].includes(formType.value));
// Computed: verificar si el usuario tiene ambos roles (vertical y horizontal)
const hasBothRoles = computed(() => {
    // Cuando ADS tramita para una cuenta, el canal depende de la cuenta, no de
    // los roles de quien está identificado.
    if (selectedAccount.value) {
        return accountHasBothTypes(selectedAccount.value);
    }
    try {
        const raw =
            localStorage.getItem('user_roles') ||
            localStorage.getItem('roles') ||
            localStorage.getItem('role') ||
            localStorage.getItem('user') ||
            localStorage.getItem('auth_user') ||
            '';
        if (!raw) {
            console.debug('all-forms: no localStorage roles key found');
            return false;
        }
        let roles = [];
        try {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed)) {
                roles = parsed;
            } else if (parsed && typeof parsed === 'object') {
                if (Array.isArray(parsed.roles)) roles = parsed.roles;
                else if (Array.isArray(parsed.role)) roles = parsed.role;
                else if (typeof parsed.role === 'string') roles = parsed.role.split(',');
                else if (parsed.user && Array.isArray(parsed.user.roles)) roles = parsed.user.roles;
                else if (typeof parsed.roles === 'string') roles = parsed.roles.split(',');
            } else if (typeof parsed === 'string') {
                roles = parsed.split(',');
            }
        } catch (e) {
            console.error('all-forms: error parsing roles JSON, falling back to raw string split', e);
            roles = raw.split(',');
        }
        roles = roles.map(r => String(r).trim().toLowerCase()).filter(Boolean);
        console.debug('all-forms: parsed roles from localStorage:', roles);
        return roles.includes('vertical') && roles.includes('horizontal');
    } catch (err) {
        console.error('all-forms: error parsing roles', err);
        return false;
    }
});

const hasRequestRoleError = ref(false);

const validateRequestRole = () => {
    // No validar en edición
    if (isEditing.value) {
        componentValidations.value.requestRole = true;
        hasRequestRoleError.value = false;
        return true;
    }

    if (!hasBothRoles.value) {
        componentValidations.value.requestRole = true;
        hasRequestRoleError.value = false;
        return true;
    }

    const isValid = !!formData.value.request_role && String(formData.value.request_role).trim() !== '';
    componentValidations.value.requestRole = isValid;
    hasRequestRoleError.value = !isValid;
    updateErrorList('requestRole', isValid);
    return isValid;
};

// ===================================================================
// MÉTODOS DE SELECCIÓN Y VALIDACIÓN PRINCIPAL
// ===================================================================
const selectOption = (value) => {
    if (isEnergyLocked.value) {
        return;
    }
    const newValue = selectedOption.value === value ? null : value;
    selectedOption.value = newValue;
    formData.value.type = newValue;
    syncCupsWithSupplySelection(newValue);
    validateSupplyType();
};

// ===================================================================
// FUNCIONES DE VALIDACIÓN
// ===================================================================
const updateErrorList = (component, isValid) => {
    if (isEditing.value) {
        console.log(`🔍 Validation skipped for ${component} (edit mode)`);
        return;
    }

    if (!isValid) {
        const errorMessage = t(`form.errors.${component}`);
        if (!errors.value.includes(errorMessage)) {
            errors.value.push(errorMessage);
        }
        fieldErrors.value[component] = errorMessage;
    } else {
        errors.value = errors.value.filter(e => e !== t(`form.errors.${component}`));
        delete fieldErrors.value[component];
    }
};

const validateSupplyType = () => {
    // Si está en modo edición, no validar
    if (isEditing.value) {
        componentValidations.value.supplysType = true;
        return true;
    }

    const isValid = selectedOption.value !== null && selectedOption.value !== undefined && selectedOption.value !== '';
    // console.log('🔍 Validating supply type, isValid:', isValid);
    hasSupplyTypeError.value = !isValid;
    componentValidations.value.supplysType = isValid;
    updateErrorList('supplysType', isValid);
    return isValid;
};

// ===================================================================
// MÉTODOS PARA CUPS
// ===================================================================
const handleCupsUpdate = (type, value) => {
    const field = type === 'gas' ? 'cups_gas' : 'cups_light';
    formData.value[field] = value;
    searchCups(type, value);
    // Limpiar el error cuando se actualiza el valor
    if (type === 'gas') {
        hasGasError.value = false;
    } else {
        hasLightError.value = false;
    }
    validateCups();
};

const clearCupsField = (type) => {
    const field = type === 'gas' ? 'cups_gas' : 'cups_light';
    formData.value[field] = '';
    cupsSuggestions.value[type] = [];
    showCupsSearch.value[type] = false;

    if (type === 'gas') {
        hasGasError.value = false;
    } else {
        hasLightError.value = false;
    }
};

const syncCupsWithSupplySelection = (selection = selectedOption.value) => {
    const normalizedSelection = normalizeSupplyType(selection);

    if (normalizedSelection !== 'luz' && normalizedSelection !== 'ambos') {
        clearCupsField('light');
    }

    if (normalizedSelection !== 'gas' && normalizedSelection !== 'ambos') {
        clearCupsField('gas');
    }
};

const toggleNoSeCups = (type) => {
    if (type) {
        sabeCUPS.value[type] = !sabeCUPS.value[type];

        if (sabeCUPS.value[type]) {
            clearCupsField(type);
        }
    } else {
        // Toggle general
        const newValue = !sabeCUPS.value.light && !sabeCUPS.value.gas;
        sabeCUPS.value = {
            light: newValue,
            gas: newValue
        };

        if (newValue) {
            clearCupsField('gas');
            clearCupsField('light');
        }
    }
    validateCups();
};

const resolveCupsByType = (suggestion, type) => {
    if (!suggestion || typeof suggestion === 'string') return suggestion || '';

    const supplies = Array.isArray(suggestion.supplies) ? suggestion.supplies : [];
    const lightFromSupplies = supplies.find((s) => normalizeSupplyType(s?.type) === 'luz')?.cups || '';
    const gasFromSupplies = supplies.find((s) => normalizeSupplyType(s?.type) === 'gas')?.cups || '';

    if (type === 'light') {
        return suggestion?.cups_light || lightFromSupplies || suggestion?.cups || suggestion?.value || '';
    }

    if (type === 'gas') {
        return suggestion?.cups_gas || gasFromSupplies || suggestion?.cups || suggestion?.value || '';
    }

    return suggestion?.cups || suggestion?.cups_light || suggestion?.cups_gas || lightFromSupplies || gasFromSupplies || suggestion?.value || '';
};

// La sugerencia es un suministro (tabla supplies + finca): solo se toman los
// datos del punto. Nunca se leen datos de solicitudes anteriores, que en el
// legacy traen correos en los campos de dirección.
const normalizeCupsSuggestion = (suggestion, type) => {
    if (typeof suggestion === 'string') {
        return {
            cups: suggestion,
            type: type === 'gas' ? 'gas' : 'luz'
        };
    }

    const normalizedType = normalizeSupplyType(suggestion?.type || (type === 'gas' ? 'gas' : 'luz'));

    return {
        cups: resolveCupsByType(suggestion, type),
        address: firstFilledValue(suggestion?.address, suggestion?.property?.address),
        postal_code: firstFilledValue(
            suggestion?.postal_code,
            suggestion?.property?.postal_code,
            postalCodeFromText(suggestion?.address),
            postalCodeFromText(suggestion?.property?.address)
        ),
        municipality: firstFilledValue(
            suggestion?.municipality,
            suggestion?.property?.municipality,
            municipalityFromText(suggestion?.address),
            municipalityFromText(suggestion?.property?.address)
        ),
        type: normalizedType
    };
};

const getCupsSuggestionValue = (suggestion, type) => {
    if (typeof suggestion === 'string') return suggestion;
    return resolveCupsByType(suggestion, type) || suggestion?.name || '';
};

const selectCupsSuggestion = (type, suggestion) => {
    const normalizedSuggestion = normalizeCupsSuggestion(suggestion, type);
    const selectedValue = getCupsSuggestionValue(normalizedSuggestion, type);
    if (!selectedValue) return;

    // Rellenar el CUPS directamente
    const field = type === 'gas' ? 'cups_gas' : 'cups_light';
    formData.value[field] = selectedValue;
    closeAutocompleteDropdowns();

    // Rellenar el resto de campos usando la misma lógica que el autocompletado de dirección
    doAutocomplete(normalizedSuggestion);

    validateCups();
};

const normalizeCupsValue = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

const searchCups = (type, query) => {
    if (sabeCUPS.value[type]) {
        showCupsSearch.value[type] = false;
        cupsSuggestions.value[type] = [];
        return;
    }

    const trimmedQuery = String(query || '').trim();
    // Dos caracteres bastan: se busca por el prefijo ES para ver los puntos ya
    // dados de alta antes de escribir el CUPS entero (ADS-0102).
    if (trimmedQuery.length < 2) {
        showCupsSearch.value[type] = false;
        cupsSuggestions.value[type] = [];
        return;
    }

    if (cupsSearchTimeouts[type]) {
        clearTimeout(cupsSearchTimeouts[type]);
    }

    cupsSearchTimeouts[type] = setTimeout(async () => {
        isSearchingCups.value[type] = true;
        try {
            const apiUrl = import.meta.env.VITE_API_URL || '';
            const token = localStorage.getItem('token');
            // Se busca en suministros (no en solicitudes) para traer la dirección real del punto
            const response = await axios.get(`${apiUrl}/supply/user/search`, {
                params: { query: trimmedQuery, search_by: 'cups', type: type === 'gas' ? 'gas' : 'light' },
                headers: { Authorization: token ? `Bearer ${token}` : '' }
            });

            const list = Array.isArray(response.data?.value?.data) ? response.data.value.data : [];

            const unique = [];
            const seen = new Set();

            list.forEach((item) => {
                const value = getCupsSuggestionValue(item, type);
                if (!value || seen.has(value)) return;
                seen.add(value);
                unique.push(item);
            });

            // El campo ha cambiado mientras se buscaba: descartar el resultado
            const field = type === 'gas' ? 'cups_gas' : 'cups_light';
            if (String(formData.value[field] || '').trim() !== trimmedQuery) return;

            // CUPS completo y válido que existe: autocompletar sin necesidad de clic
            if (validateCUPS(trimmedQuery)) {
                const normalizedQuery = normalizeCupsValue(trimmedQuery);
                const exactMatch = unique.find((item) => normalizeCupsValue(getCupsSuggestionValue(item, type)) === normalizedQuery);
                if (exactMatch) {
                    cupsSuggestions.value[type] = [];
                    showCupsSearch.value[type] = false;
                    selectCupsSuggestion(type, exactMatch);
                    return;
                }
            }

            cupsSuggestions.value[type] = unique;
            showCupsSearch.value[type] = unique.length > 0;
        } catch {
            cupsSuggestions.value[type] = [];
            showCupsSearch.value[type] = false;
        } finally {
            isSearchingCups.value[type] = false;
        }
    }, 300);
};

const CUPS_CONTROL_MAP = 'TRWAGMYFPDXBNJZSQVHLCKE';

const calculateCupsControl = (numericPart) => {
    if (!/^\d{16}$/.test(numericPart)) return null;

    // Se calcula el modulo de forma incremental para evitar problemas de precision.
    let remainder = 0;
    for (const digit of numericPart) {
        remainder = (remainder * 10 + Number(digit)) % 529;
    }

    const firstControlIndex = Math.floor(remainder / 23);
    const secondControlIndex = remainder % 23;
    return `${CUPS_CONTROL_MAP[firstControlIndex]}${CUPS_CONTROL_MAP[secondControlIndex]}`;
};

const validateCUPS = (value) => {
    const normalizedValue = String(value || '').trim().toUpperCase();
    const cupsRegex = /^ES\d{16}[A-Z]{2}([A-Z0-9]{2})?$/;

    if (!cupsRegex.test(normalizedValue)) return false;

    const numericPart = normalizedValue.slice(2, 18);
    const providedControl = normalizedValue.slice(18, 20);
    const expectedControl = calculateCupsControl(numericPart);

    return expectedControl !== null && providedControl === expectedControl;
};

const validateCups = () => {
    // Modificar una solicitud aplica la misma validación que crearla: antes se
    // saltaba entera y se podía guardar un CUPS inválido (ADS-0075).
    let isValid = true;
    hasLightError.value = false;
    hasGasError.value = false;

    if (selectedOption.value === 'ambos') {
        if (!sabeCUPS.value.light) {
            if (!formData.value.cups_light) {
                hasLightError.value = true;
                isValid = false;
            } else if (!validateCUPS(formData.value.cups_light)) {
                hasLightError.value = true;
                isValid = false;
            }
        }
        if (!sabeCUPS.value.gas) {
            if (!formData.value.cups_gas) {
                hasGasError.value = true;
                isValid = false;
            } else if (!validateCUPS(formData.value.cups_gas)) {
                hasGasError.value = true;
                isValid = false;
            }
        }
    } else if (selectedOption.value === 'luz') {
        if (!sabeCUPS.value.light) {
            if (!formData.value.cups_light) {
                hasLightError.value = true;
                isValid = false;
            } else if (!validateCUPS(formData.value.cups_light)) {
                hasLightError.value = true;
                isValid = false;
            }
        }
    } else if (selectedOption.value === 'gas') {
        if (!sabeCUPS.value.gas) {
            if (!formData.value.cups_gas) {
                hasGasError.value = true;
                isValid = false;
            } else if (!validateCUPS(formData.value.cups_gas)) {
                hasGasError.value = true;
                isValid = false;
            }
        }
    }

    // Solo actualizar las validaciones si el formulario ha sido enviado
    if (isSubmitted.value) {
        componentValidations.value.knowCups = isValid;
        updateErrorList('knowCups', isValid);
    }
    return isValid;
};

// Watch para CUPS
watch(() => isSubmitted.value, (newValue) => {
    if (newValue) {
        validateCups();
    } else {
        hasLightError.value = false;
        hasGasError.value = false;
    }
});

watch(() => selectedOption.value, () => {
    hasLightError.value = false;
    hasGasError.value = false;
    sabeCUPS.value = {
        light: false,
        gas: false
    };
    syncCupsWithSupplySelection();
    validateCups();
});

// Métodos para la cuenta bancaria
const handleIbanUpdate = (value) => {
    formData.value.iban = value;
    validateBankAccount();
};

const handleTelephoneUpdate = (value) => {
    hasTelephoneInvalidCharacters.value = /[^\d]/.test(String(value || ''));
    formData.value.telephone = normalizeTelephoneForApi(value);

    if (isSubmitted.value) {
        validateOwnerData();
    }
};

const handleTelephoneUnavailableChange = (checked) => {
    formData.value.telephone_unavailable = checked === true;

    if (formData.value.telephone_unavailable) {
        formData.value.telephone = '';
        hasTelephoneInvalidCharacters.value = false;
    }

    if (isSubmitted.value) {
        validateOwnerData();
    }
};

const validateBankAccount = () => {
    // Si está en modo edición, no validar
    if (isEditing.value) {
        componentValidations.value.bankAccount = true;
        return true;
    }

    const iban = formData.value.iban?.trim();

    // IBAN es opcional; si está vacío se considera válido
    if (!iban) {
        hasBankError.value = false;
        componentValidations.value.bankAccount = true;
        updateErrorList('bankAccount', true);
        return true;
    }

    // Si hay IBAN, validar el formato (ES + 22 dígitos)
    const ibanRegex = /^ES\d{22}$/;
    const isValid = ibanRegex.test(iban);

    hasBankError.value = !isValid;
    componentValidations.value.bankAccount = isValid;
    updateErrorList('bankAccount', isValid);
    return isValid;
};

/**
 * Ofrece «No dispongo» solo cuando el guardado falla porque el teléfono quedó
 * vacío. Si lo que hay es un número mal escrito, lo que corresponde es
 * corregirlo, no declarar que no se tiene.
 */
const offerTelephoneUnavailable = (telephoneValid, telephoneValue) => {
    if (isSubmitted.value && !telephoneValid && !telephoneValue) {
        telephoneUnavailableOffered.value = true;
    }
};

// Métodos para datos del titular
const validateOwnerData = () => {
    if (isEditing.value) {
        const telephoneValue = String(formData.value.telephone || '').trim();
        const telephoneValid = telephoneLocked.value
            || formData.value.telephone_unavailable
            || (!hasTelephoneInvalidCharacters.value && !!telephoneValue && validatetelephone(telephoneValue));

        offerTelephoneUnavailable(telephoneValid, telephoneValue);

        hasOwnerError.value = {
            name: false,
            dni: false,
            email: false,
            telephone: !telephoneValid
        };
        componentValidations.value.ownerDate = telephoneValid;
        updateErrorList('ownerDate', telephoneValid);
        return telephoneValid;
    }

    // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
    // const requiresFullOwnerData = formType.value === 'supplies' || formType.value === 'change_ownership' || formType.value === 'change_supplier';
    const requiresFullOwnerData = formType.value === 'supplies' || formType.value === 'change_ownership';

    const nameValid = requiresFullOwnerData ? !!formData.value.contact_name?.trim() : true;
    // DNI/NIE/NIF/Pasaporte es requerido solo para formularios con datos completos del titular
    const dniValid = requiresFullOwnerData ? !!formData.value.dni_nie?.trim() : true;
    const emailValid = requiresFullOwnerData
        ? (!!formData.value.email?.trim() && validateEmail(formData.value.email))
        : true;

    const telephoneValue = String(formData.value.telephone || '').trim();
    const requiresTelephone = REQUIRED_TELEPHONE_FORM_TYPES.includes(formType.value);
    const telephoneValid = formData.value.telephone_unavailable
        ? true
        : requiresTelephone
        ? (!hasTelephoneInvalidCharacters.value && !!telephoneValue && validatetelephone(telephoneValue))
        : (!hasTelephoneInvalidCharacters.value && (!telephoneValue || validatetelephone(telephoneValue)));

    offerTelephoneUnavailable(telephoneValid, telephoneValue);

    hasOwnerError.value = {
        name: !nameValid,
        dni: !dniValid,
        email: !emailValid,
        telephone: !telephoneValid
    };

    const isValid = nameValid && dniValid && emailValid && telephoneValid;
    componentValidations.value.ownerDate = isValid;
    updateErrorList('ownerDate', isValid);
    return isValid;
};

// Métodos para dirección
// const toggleDifferentAddress = (event) => {
//     isDifferentAddress.value = event.target.checked;
//     if (!isDifferentAddress.value) {
//         formData.value.user_address = formData.value.supply_address;
//         // Limpiar el error de correspondencia cuando se desactiva
//         hasAddressError.value.correspondence = false;
//     }
// };
watch(isDifferentAddress, (newValue) => {
    if (!newValue) {
        formData.value.user_address = formData.value.supply_address;
        formData.value.correspondence_population = formData.value.municipality;
        // Limpiar el error de correspondencia cuando se desactiva
        hasAddressError.value.correspondence = false;
        hasAddressError.value.correspondencePopulation = false;
    }
});

const validateAddress = () => {
    const addressErrors = validateSupplyAddress(formType.value, formData.value);
    const supplyValid = !addressErrors.supply;
    const postalValid = !addressErrors.postal;
    const municipalityValid = !addressErrors.municipality;

    // Validación de la dirección de correspondencia (solo si isDifferentAddress es true)
    const correspondenceValid = isEditing.value || !isDifferentAddress.value ||
        (isDifferentAddress.value && !!formData.value.user_address?.trim());

    // Validación de la población de correspondencia (solo si isDifferentAddress es true)
    const correspondencePopulationValid = isEditing.value || !isDifferentAddress.value ||
        (isDifferentAddress.value && !!formData.value.correspondence_population?.trim());

    // Actualiza los estados de error
    hasAddressError.value = {
        supply: !supplyValid,
        postal: !postalValid,
        correspondence: !correspondenceValid,
        correspondencePopulation: !correspondencePopulationValid,
        municipality: !municipalityValid
    };

    // La validación es exitosa si todos los campos requeridos son válidos
    const isValid = supplyValid && postalValid && municipalityValid && correspondenceValid && correspondencePopulationValid;

    // Actualiza las validaciones en el componente
    componentValidations.value.supplysDate = isValid;
    componentValidations.value.addressCp = isValid;
    updateErrorList('supplysDate', isValid);
    return isValid;
};

const validateConditions = () => {
    // Una solicitud que ya tiene sus consentimientos no vuelve a pedirlos al
    // modificarla: valen los que se dieron en su día (ADS-0127).
    const isValid = consentChecked('terms') === true && consentChecked('dataProcessing') === true;
    hasConditionsError.value = !isValid;
    return isValid;
};

// Watch para validar la dirección cuando cambian los campos
watch(() => formData.value.supply_address, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

watch(() => formData.value.postal_code, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

watch(() => formData.value.municipality, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

watch(() => formData.value.user_address, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

watch(() => formData.value.correspondence_population, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

watch(() => isDifferentAddress.value, () => {
    if (isSubmitted.value) {
        validateAddress();
    }
});

// Métodos para archivos
const ALLOWED_FILE_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv'
];
const ALLOWED_FILE_EXTENSIONS = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'xls', 'xlsx', 'csv'];

const isAllowedFileType = (file) => {
    if (ALLOWED_FILE_MIME_TYPES.includes(file.type)) {
        return true;
    }
    const extension = file.name.split('.').pop()?.toLowerCase();
    return extension ? ALLOWED_FILE_EXTENSIONS.includes(extension) : false;
};

const triggerFileUpload = () => {
    fileInput.value.click();
};

const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) {
        // Los archivos ya no son obligatorios, no mostrar error
        return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB

    for (const file of files) {
        if (!isAllowedFileType(file)) {
            fileErrorKey.value = 'invalid_type';
            fileError.value = true;
            componentValidations.value.fileUpload = false;
            updateErrorList('fileUpload', false);
            return;
        }

        if (file.size > maxSize) {
            fileErrorKey.value = 'size_limit';
            fileError.value = true;
            componentValidations.value.fileUpload = false;
            updateErrorList('fileUpload', false);
            return;
        }

        await uploadFile(file);
    }

    event.target.value = '';
};

const uploadFile = async (file) => {
    const fileFormData = new FormData();
    fileFormData.append('file', file);

    try {
        const response = await axios.post(
            `${import.meta.env.VITE_API_URL}/request/upload/form`,
            fileFormData,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

        if (response.data?.value) {
            const newFile = {
                file_url: response.data.value.file_url,
                file_name: response.data.value.file_name,
                documental_type: ''
            };
            uploadedFiles.value.push(newFile);
            formData.value.files = [...uploadedFiles.value];

            fileErrorKey.value = '';
            fileError.value = false;
            validateDocumentalTypes();
        } else {
            throw new Error('Formato de respuesta no válido');
        }
    } catch (err) {
        console.error('Error al subir el archivo:', err);
        if (err.response && err.response.status === 422) {
            fileErrorKey.value = 'invalid_type';
        } else if (err.response && err.response.status === 413) {
            fileErrorKey.value = 'size_limit';
        } else {
            fileErrorKey.value = 'upload_error';
        }
        fileError.value = true;
        componentValidations.value.fileUpload = false;
        updateErrorList('fileUpload', false);
    }
};

const removeFile = (index) => {
    uploadedFiles.value.splice(index, 1);
    formData.value.files = [...uploadedFiles.value];

    validateDocumentalTypes();
};

const validateDocumentalTypes = () => {
    const isValid = uploadedFiles.value.length === 0 || uploadedFiles.value.every(file => !!file.documental_type);
    documentalTypeError.value = !isValid;
    componentValidations.value.fileUpload = isValid;
    updateErrorList('fileUpload', isValid);
    return isValid;
};

const handleDocumentalTypeChange = () => {
    formData.value.files = uploadedFiles.value.map(file => ({ ...file }));
    validateDocumentalTypes();
};

// Watch para validar archivos cuando se envía el formulario
watch(() => isSubmitted.value, (newValue) => {
    if (newValue) {
        fileError.value = false;
        fileErrorKey.value = '';
        validateDocumentalTypes();
    }
});

// Watch para limpiar errores cuando se suben archivos
watch(uploadedFiles, () => {
    fileErrorKey.value = '';
    fileError.value = false;
    validateDocumentalTypes();
}, { deep: true });

// ===================================================================
// FUNCIONES AUXILIARES DE VALIDACIÓN
// ===================================================================
function validateEmail(value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
}

function validatetelephone(value) {
    // El teléfono del titular son exactamente 9 dígitos, y es obligatorio salvo
    // que se marque «No dispongo». Antes se admitían de 8 a 15. El resto de los
    // teléfonos de la plataforma conservan la regla anterior.
    const telephoneRegex = /^[0-9]{9}$/;
    return telephoneRegex.test(String(value || ''));
}

function normalizeTelephoneForApi(value) {
    return String(value || '').replace(/[^\d]/g, '');
}

/** "Aceptado el 15/09/2026", o "No aceptado" para el consentimiento voluntario. */
const consentLabel = (key) => {
    const date = storedConsents.value[key];
    if (!date) return t('conditionsCheck.notAccepted');
    const parsed = new Date(date);
    return t('conditionsCheck.acceptedOn', {
        date: Number.isNaN(parsed.getTime()) ? String(date) : parsed.toLocaleDateString(),
    });
};

function buildRequestPayload(baseData, userId) {
    const payload = {
        ...baseData,
        type: formType.value,
        assigned_to: formData.value.assigned_to ? parseInt(formData.value.assigned_to) : null,
        // Con cuenta cliente, el back fija la persona (`manager`) a partir de
        // ella; sin cuenta se mantiene el contrato anterior.
        client_account_id: formData.value.client_account_id ? parseInt(formData.value.client_account_id) : null,
        manager: formData.value.client_account_id
            ? null
            : (formData.value.manager ? parseInt(formData.value.manager) : userId),
        files: (formData.value.files || []).map(f => ({
            file_name: f.file_name,
            file_path: f.file_url || f.file_path,
            documental_type: f.documental_type || null
        }))
    };

    delete payload.company;
    delete payload.liquidate;
    delete payload.liquidation;
    delete payload.liquidation_details;
    delete payload.supplyStatus;
    delete payload.supply_status;
    delete payload.registration_classification;
    delete payload.pending_reason;
    delete payload.noMunicipality;

    // Datos del titular: en blanco se guardan como nulos (ADS-0171).
    for (const field of ['contact_name', 'contact_surname', 'dni_nie']) {
        payload[field] = String(payload[field] || '').trim() || null;
    }

    const supplyType = normalizeSupplyType(selectedOption.value);

    // Luz, gas o ambos se guarda tal cual: sin CUPS (alta nueva, «No sé el CUPS»)
    // es lo único que permite listar la solicitud en Luz o Gas del cliente.
    payload.supply_type = { luz: 'light', gas: 'gas', ambos: 'both' }[supplyType] ?? null;

    if (supplyType === 'luz') {
        payload.cups_gas = null;
    } else if (supplyType === 'gas') {
        payload.cups_light = null;
    } else if (!supplyType) {
        payload.cups_light = null;
        payload.cups_gas = null;
    }

    if (sabeCUPS.value.light) {
        payload.cups_light = null;
    }

    if (sabeCUPS.value.gas) {
        payload.cups_gas = null;
    }

    // Vínculo con el suministro de origen y su inmueble (ADS-0125). Solo se
    // envía cuando existe: el formulario no desvincula una solicitud.
    for (const [field, applies] of [
        ['supply_light_id', supplyType !== 'gas'],
        ['supply_gas_id', supplyType !== 'luz'],
        ['property_id', true],
    ]) {
        const value = applies ? formData.value[field] : null;
        if (value) {
            payload[field] = parseInt(value);
        } else {
            delete payload[field];
        }
    }

    if (showsMeterReadings.value) {
        payload.light_meter_reading = supplyType === 'gas' ? null : (String(payload.light_meter_reading || '').trim() || null);
        payload.gas_meter_reading = supplyType === 'luz' ? null : (String(payload.gas_meter_reading || '').trim() || null);
    } else {
        // El campo no se muestra en estas tipologías: no se envía, así no se
        // crean lecturas nuevas ni se pisan las heredadas de la migración.
        delete payload.light_meter_reading;
        delete payload.gas_meter_reading;
    }

    if (formType.value === 'other_type' && payload.other_action !== 'cambio_direccion_postal') {
        payload.email = null;
    }

    if (telephoneLocked.value) {
        // El teléfono (o «No dispongo») de la solicitud original no se toca.
        delete payload.telephone;
        delete payload.telephone_unavailable;
    } else {
        payload.telephone_unavailable = Boolean(payload.telephone_unavailable);
        payload.telephone = payload.telephone_unavailable
            ? null
            : (normalizeTelephoneForApi(payload.telephone) || null);
    }

    // Modificar no puede vaciar la cuenta, la persona ni el canal de una
    // solicitud: si el formulario no los trae, no viajan.
    if (isEditMode.value) {
        for (const field of ['client_account_id', 'manager', 'request_role']) {
            if (payload[field] === null || payload[field] === '' || payload[field] === undefined) delete payload[field];
        }
    }

    // Los consentimientos se dan una vez, al crear la solicitud: al modificarla
    // no viajan, ni siquiera sus fechas, para no tocar los originales (ADS-0127).
    for (const field of Object.values(CONSENT_DATE_FIELDS)) delete payload[field];
    if (isEditMode.value) {
        for (const field of ['accepted_terms', 'accepted_data_processing', 'accepted_commercial_comms']) delete payload[field];
    } else {
        payload.accepted_terms = acceptConditions.value === true;
        payload.accepted_data_processing = acceptDataProcessing.value === true;
        payload.accepted_commercial_comms = acceptCommercialComms.value === true;
    }

    return payload;
}

// Función de validación general
function validateForm() {
    // Si está en modo edición, no validar
    if (isEditing.value) {
        return true;
    }

    let isValid = true;
    errors.value = [];
    fieldErrors.value = {};

    // Validar tipo de suministro (común para todos)
    if (!validateSupplyType()) isValid = false;

    // Validar CUPS (común para todos)
    if (!validateCups()) isValid = false;

    // Validaciones específicas por tipo de formulario
    switch (formType.value) {
        case 'supplies':
            if (!validateOwnerData()) isValid = false;
            if (!validateBankAccount()) isValid = false;
            if (!validateAddress()) isValid = false;
            break;

        case 'change_ownership':
        // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
        // case 'change_supplier':
            if (!validateOwnerData()) isValid = false;
            if (!validateBankAccount()) isValid = false;
            if (!validateAddress()) isValid = false;
            break;

        case 'account_change':
            if (!validateOwnerData()) isValid = false;
            if (!validateBankAccount()) isValid = false;
            if (!validateAddress()) isValid = false;
            break;

        case 'invoice':
            if (!validateOwnerData()) isValid = false;
            if (!validateAddress()) isValid = false;
            break;

        case 'other_type':
            hasOtherActionError.value = !formData.value.other_action;
            if (hasOtherActionError.value) isValid = false;
            if (!validateOwnerData()) isValid = false;
            if (!validateAddress()) isValid = false;
            if (!validateBankAccount()) isValid = false;
            break;
    }

    if (!validateConditions()) isValid = false;

    // ADS debe indicar para qué cliente tramita
    if (!validateClientAccount()) isValid = false;

    // Validar request_role si aplica
    if (!validateRequestRole()) isValid = false;

    // Los archivos son opcionales, pero cada archivo añadido debe clasificarse.
    if (!validateDocumentalTypes()) isValid = false;

    return isValid;
}

// Métodos para el formulario
const handleSubmitStart = () => {
    console.log('Form submission started:', {
        isEditing: isEditing.value,
        formData: formData.value,
        validations: componentValidations.value,
        isFormValid: isFormValid.value,
        selectedOption: selectedOption.value
    });

    // Reset errors and set submitted state
    errors.value = [];
    fieldErrors.value = {};
    isSubmitted.value = true;

    // Solo validar si no está en modo edición
    if (!isEditing.value) {
        validateForm();
    }
};

// Función para generar mensaje de error simple
const getSimpleErrorMessage = () => {
    const errorFields = [];

    // Verificar cada campo y agregar su nombre si tiene error
    if (hasSupplyTypeError.value) {
        errorFields.push('Tipo de suministro');
    }

    if (hasLightError.value) {
        errorFields.push('CUPS de luz');
    }

    if (hasGasError.value) {
        errorFields.push('CUPS de gas');
    }

    if (hasOwnerError.value.name) {
        errorFields.push('Nombre completo');
    }

    if (hasOwnerError.value.dni) {
        errorFields.push('DNI/NIE/NIF/Pasaporte');
    }

    if (hasOwnerError.value.email) {
        errorFields.push('Email');
    }

    if (hasOwnerError.value.telephone) {
        errorFields.push(t('ownerForm.labels.telephone'));
    }

    if (hasBankError.value) {
        errorFields.push('Formato de IBAN incorrecto');
    }

    if (hasOtherActionError.value) {
        errorFields.push(t('requestTypeChange.subcategoryLabel'));
    }

    if (hasAddressError.value.supply) {
        errorFields.push('Dirección del suministro');
    }

    if (hasAddressError.value.postal) {
        errorFields.push('Código postal');
    }

    if (hasAddressError.value.municipality) {
        errorFields.push('Municipio');
    }

    if (hasAddressError.value.correspondence) {
        errorFields.push('Dirección de correspondencia');
    }

    if (hasObservationError.value) {
        errorFields.push('Observaciones');
    }

    if (hasConditionsError.value) {
        errorFields.push('Aceptar condiciones');
    }

    if (documentalTypeError.value) {
        errorFields.push(t('requestFiles.modal.documentalType'));
    }

    if (hasClientAccountError.value) {
        errorFields.push(t('form.client.title'));
    }

    if (errorFields.length === 0) {
        return 'Por favor, complete todos los campos requeridos';
    }

    return `Campos requeridos: ${errorFields.join(', ')}`;
};

const submitForm = async () => {
    if (isSubmitting.value) return;
    if (isEditMode.value) {
        await submitFormUpdate();
        return;
    }

    console.log('🔍 Payload:', formData.value);
    handleSubmitStart();
    const formIsValid = validateForm();
    if (!formIsValid) {
        const errorMessage = getSimpleErrorMessage();
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return;
    }

    const acceptImprovement = contractImprovementAccepted.value && !canPickClientAccount.value && supportsContractImprovement(formType.value);
    contractImprovementError.value = '';
    if (acceptImprovement) {
        const missing = [];
        if (!contractImprovementDni.value) missing.push(t('contractImprovement.documents.dni'));
        if (!contractImprovementBank.value && !normalizeIban(contractImprovementIban.value)) missing.push(t('contractImprovement.bankAlternative'));
        if (missing.length) contractImprovementError.value = t('contractImprovement.errors.missing', { documents: missing.join(', ') });
        else if (normalizeIban(contractImprovementIban.value) && !isValidIban(contractImprovementIban.value)) contractImprovementError.value = t('contractImprovement.errors.iban');
        else if ([contractImprovementDni.value, contractImprovementBank.value].some((file) => file && (file.size > 5 * 1024 * 1024 || !/\.(pdf|jpe?g|png|docx?)$/i.test(file.name)))) contractImprovementError.value = t('contractImprovement.formats');
        if (contractImprovementError.value) {
            toast.error(contractImprovementError.value);
            return;
        }
    }

    isSubmitting.value = true;
    try {
        const id = localStorage.getItem('id');
        const restFormData = { ...formData.value };
        const payload = buildRequestPayload(restFormData, id);

        const response = await axios.post(
            `${import.meta.env.VITE_API_URL}/request/create`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        if (response.data && response.data.value) {
            if (acceptImprovement) {
                const requestId = response.data.value.id;
                const documents = new FormData();
                documents.append('accepted', '1');
                documents.append('dni_file', contractImprovementDni.value);
                if (contractImprovementBank.value) documents.append('bank_file', contractImprovementBank.value);
                if (normalizeIban(contractImprovementIban.value)) documents.append('iban', normalizeIban(contractImprovementIban.value));
                try {
                    await axios.post(`${import.meta.env.VITE_API_URL}/request/contract-improvement/${requestId}`, documents, {
                        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                    });
                } catch (acceptanceError) {
                    const apiErrors = acceptanceError.response?.data?.errors;
                    const reason = apiErrors ? Object.values(apiErrors).flat().join(', ') : (acceptanceError.response?.data?.message || t('contractImprovement.errors.generic'));
                    toast.error(`${t('contractImprovement.createNotSaved')} ${reason}`);
                    errors.value = [`${t('contractImprovement.createNotSaved')} ${reason}`];
                    // El alta ya existe: abrir su detalle para completar la aceptación sin duplicarla.
                    redirectToDetail(requestId);
                    return;
                }
            }
            toast.success(
                isEditing.value
                    ? t('suppliesForm.success.updated')
                    : t('suppliesForm.success.created'),
                {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
            await new Promise((resolve) => setTimeout(resolve, 1000));
            emit('submit-success', response.data);
            errors.value = [];
            redirectToDetail(response.data.value.id);
        } else {
            throw new Error('Formato de respuesta no válido');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
        let errorMessage = t('suppliesForm.errors.submit');
        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (typeof error.response?.data?.value === 'string') {
            errorMessage = error.response.data.value;
        }
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        emit('submit-error', error);
    } finally {
        isSubmitting.value = false;
    }
};

const submitFormUpdate = async () => {
    console.log('🔍 submitFormUpdate called:', {
        isEditing: isEditMode.value,
        isFormValid: isFormValid.value,
        formData: formData.value
    });

    isSubmitted.value = true;

    // En modo edición, no validar el formulario
    if (!isEditMode.value && !isFormValid.value) {
        const errorMessage = getSimpleErrorMessage();
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return;
    }

    if (!validateOwnerData()) {
        const errorMessage = getSimpleErrorMessage();
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return;
    }

    if (!validateCups()) {
        const errorMessage = getSimpleErrorMessage();
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return;
    }

    if (!validateConditions()) {
        const errorMessage = getSimpleErrorMessage();
        errors.value = [errorMessage];
        toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return;
    }

    try {
        const id = localStorage.getItem('id');
        const updateData = { ...formData.value };
        // No enviar el campo `status` en la petición de actualización
        delete updateData.status;
        const payload = buildRequestPayload(updateData, id);

        const response = await axios.put(
            `${import.meta.env.VITE_API_URL}/request/update/${formData.value.id}`,
            payload,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        toast.success(
            isEditing.value
                ? t('suppliesForm.success.updated')
                : t('suppliesForm.success.created'),
            {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            }
        );
        emit('submit-success', response.data);
        redirectToDetail(formData.value.id);
    } catch (error) {
        console.error('Error en la actualización:', error);
        errors.value = [t('form.errors.update')];
        toast.error(t('form.errors.update'), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        emit('submit-error', error);
    }
};

const cancelForm = () => {
    if (window.history.length > 1) {
        router.back();
    } else {
        router.push('/request');
    }
};

const redirectToDetail = (requestId) => {
    const role = localStorage.getItem('role');
    const detailRoute = role === 'superadmin' ? '/request-detail-superadmin' : '/request-detail';
    router.push(`${detailRoute}/${requestId}`);
};

// ===================================================================
// MÉTODOS PARA BÚSQUEDA DE USUARIOS
// ===================================================================
// const openUserSearchModal = () => {
//     showUserSearchModal.value = true;
//     userSearchQuery.value = '';
//     searchedUsers.value = [];
// };

const closeUserSearchModal = () => {
    showUserSearchModal.value = false;
    userSearchQuery.value = '';
    searchedUsers.value = [];
    isSearchingUsers.value = false;
    if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
        searchTimeout.value = null;
    }
};

// ===================================================================
// MÉTODOS PARA BÚSQUEDA DE CUENTAS CLIENTE
// ===================================================================
// Personal de ADS que puede tramitar en nombre de un cliente. Coincide con
// `User::isAdsUser()` en el back, que es quien autoriza `/client-account/search`.
const canPickClientAccount = computed(() => hasAnyRole(['superadmin', 'admin', 'comercial']));

const openAccountSearchModal = () => {
    showAccountSearchModal.value = true;
    accountSearchQuery.value = '';
    searchedAccounts.value = [];
};

const closeAccountSearchModal = () => {
    showAccountSearchModal.value = false;
    accountSearchQuery.value = '';
    searchedAccounts.value = [];
    isSearchingAccounts.value = false;
    if (accountSearchTimeout.value) {
        clearTimeout(accountSearchTimeout.value);
        accountSearchTimeout.value = null;
    }
};

const searchAccounts = () => {
    const query = accountSearchQuery.value.trim();
    if (!query) {
        searchedAccounts.value = [];
        return;
    }

    if (accountSearchTimeout.value) {
        clearTimeout(accountSearchTimeout.value);
    }

    isSearchingAccounts.value = true;
    accountSearchTimeout.value = setTimeout(async () => {
        try {
            const response = await axios.get(`${import.meta.env.VITE_API_URL}/client-account/search`, {
                params: { query, per_page: 20 },
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });

            const page = response.data?.value;
            searchedAccounts.value = Array.isArray(page?.data) ? page.data : [];
        } catch (error) {
            console.error('Error searching client accounts:', error);
            searchedAccounts.value = [];
            toast.error(t('form.client.searchError'));
        } finally {
            isSearchingAccounts.value = false;
        }
    }, 300);
};

const selectAccount = (account) => {
    selectedAccount.value = account;
    formData.value.client_account_id = String(account.id);
    formData.value.manager = '';
    hasClientAccountError.value = false;
    // El canal se vuelve a decidir para la cuenta elegida.
    if (!accountHasBothTypes(account)) {
        formData.value.request_role = '';
    }
    closeAccountSearchModal();
};

const applyClientAccountId = async (accountId) => {
    try {
        const response = await axios.get(`${import.meta.env.VITE_API_URL}/client-account/get/${accountId}`, {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        if (response.data?.value) {
            selectAccount(response.data.value);
        }
    } catch (error) {
        console.error('Error loading client account:', error);
    }
};

// Enlace antiguo con `user_id`: puede ser una cuenta (propietaria de una
// comunidad) o una persona. Se consulta cuál es antes de decidir qué campo
// rellenar, porque el back ya no acepta el id de una cuenta como `manager`.
const applyPrefilledClientId = async (id) => {
    try {
        const { kind, value } = await fetchAccountDetailWithKind(id);
        if (kind === 'account' && value) {
            selectAccount(value);
            return;
        }
    } catch (error) {
        console.error('Error resolving prefilled client:', error);
    }
    formData.value.manager = String(id);
};

const validateClientAccount = () => {
    if (isEditing.value || !canPickClientAccount.value) {
        hasClientAccountError.value = false;
        return true;
    }

    const isValid = !!formData.value.client_account_id;
    hasClientAccountError.value = !isValid;
    return isValid;
};

const searchUsers = async () => {
    const query = userSearchQuery.value.trim();
    if (!query) {
        searchedUsers.value = [];
        return;
    }

    if (searchTimeout.value) {
        clearTimeout(searchTimeout.value);
    }

    isSearchingUsers.value = true;
    searchTimeout.value = setTimeout(async () => {
        try {
            const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/search`, {
                params: { query, search_by: 'name', status_filter: 'active' },
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });

            const usersPage = response.data?.value;
            searchedUsers.value = Array.isArray(usersPage?.data) ? usersPage.data : [];
        } catch (error) {
            console.error('Error searching users:', error);
            searchedUsers.value = [];
        } finally {
            isSearchingUsers.value = false;
        }
    }, 300);
};

const selectUser = (user) => {
    formData.value.assigned_to = String(user.id);
    assignedUserName.value = user.name || String(user.id);
    closeUserSearchModal();
};

// ===================================================================
// COMPUTED PROPERTIES FINALES
// ===================================================================
const isFormValid = computed(() => {
    const validations = { ...componentValidations.value };

    if (formType.value === 'supplies') {
        return validations.supplysType &&
            validations.knowCups &&
            validations.ownerDate &&
            validations.bankAccount &&
            validations.supplysDate &&
            validations.fileUpload;
    }

    // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
    // if (formType.value === 'change_ownership' || formType.value === 'change_supplier') {
    if (formType.value === 'change_ownership') {
        return validations.supplysType &&
            validations.knowCups &&
            validations.ownerDate &&
            validations.supplysDate &&
            validations.fileUpload;
    }

    if (formType.value === 'account_change') {
        return validations.supplysType &&
            validations.knowCups &&
            validations.ownerDate &&
            validations.bankAccount &&
            validations.addressCp &&
            validations.fileUpload;
    }

    if (formType.value === 'invoice') {
        return validations.supplysType &&
            validations.knowCups &&
            validations.ownerDate &&
            validations.addressCp &&
            validations.fileUpload;
    }

    if (formType.value === 'other_type') {
        return validations.supplysType &&
            validations.knowCups &&
            validations.ownerDate &&
            validations.supplysDate &&
            validations.bankAccount &&
            validations.fileUpload;
    }

    return false;
});

const getFormTitle = computed(() => {
    switch (formType.value) {
        case 'supplies':
            return !isEditing.value ? t('suppliesForm.titles.new') : t('suppliesForm.titles.edit');
        case 'change_ownership':
            return !isEditing.value ? t('form.change-ownership.mainTitle') : t('form.change-ownership.editTitle');
        // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
        // case 'change_supplier':
        //     return !isEditing.value ? t('form.change-supplier.mainTitle') : t('form.change-supplier.editTitle');
        case 'account_change':
            return !isEditing.value ? t('form.account-change.change') : t('form.account-change.edit');
        case 'invoice':
            return !isEditing.value ? t('form.invoice-request.mainTitle') : t('form.invoice-request.editTitle');
        case 'other_type':
            return !isEditing.value ? t('form.otherType.mainTitle') : t('form.otherType.editTitle');
        default:
            return '';
    }
});

const getFormSubtitle = computed(() => {
    switch (formType.value) {
        case 'supplies':
            return t('form.subtitle');
        case 'change_ownership':
            return t('form.change-ownership.subtitle');
        // Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.
        // case 'change_supplier':
        //     return t('form.change-supplier.subtitle');
        case 'account_change':
            return t('form.subtitle');
        case 'invoice':
            return t('form.invoice-request.subtitle');
        case 'other_type':
            return t('form.otherType.subtitle');
        default:
            return '';
    }
});

// Retirada «Cambio de comercializadora» (ADS-0130): se deja comentada, no borrada, por si hubiera que reponerla.: ambos dependían solo de esa tipología, así que la plantilla usa
// directamente los textos por defecto.
// const ownerSectionTitle = computed(() => (
//     formType.value === 'change_supplier' ? t('form.change-supplier.ownerTitle') : t('ownerForm.title')
// ));
//
// const ownerEmailLabel = computed(() => (
//     formType.value === 'change_supplier' ? t('form.change-supplier.emailLabel') : t('ownerForm.labels.email')
// ));

// Watchers
watch(() => isSubmitted.value, (newValue) => {
    if (newValue) {
        validateForm();
    }
});

watch(() => selectedOption.value, () => {
    hasSupplyTypeError.value = false;
    hasLightError.value = false;
    hasGasError.value = false;
    validateForm();
});

watch(() => formData.value.other_action, (value) => {
    if (value) hasOtherActionError.value = false;
});

watch([acceptConditions, acceptDataProcessing], () => {
    if (acceptConditions.value && acceptDataProcessing.value) {
        hasConditionsError.value = false;
    }
});

// ===================================================================
// EMITS
// ===================================================================
const emit = defineEmits(['submit-start', 'submit-success', 'submit-error', 'update:errors']);
</script>

<style scoped>
/*
 * Consentimientos de la solicitud original (ADS-0127): bloqueados y en gris,
 * pero con la marca bien visible. Un checkbox deshabilitado se pinta tan claro
 * que no se distingue del que nunca se marcó.
 */
.consent-locked {
    accent-color: #6b7280;
    opacity: 1;
}
</style>
